// Lightweight i18n: 7 languages
export const LANGS = [
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
];

export const T = {
  app_tagline: {
    es: "San Juan del Sur Surf, Mareas, Clima y Comunidad!",
    en: "San Juan del Sur Surf, Tides, Weather, & Community!",
    fr: "San Juan del Sur Surf, Marées, Météo et Communauté !",
    de: "San Juan del Sur Surf, Gezeiten, Wetter & Community!",
    zh: "San Juan del Sur 冲浪、潮汐、天气和社区！",
    it: "San Juan del Sur Surf, Maree, Meteo e Comunità!",
    ru: "San Juan del Sur Сёрфинг, Приливы, Погода и Сообщество!",
  },
  app_subtagline: {
    es: "Reportes diarios y semanales para la costa Pacífica de Nicaragua.",
    en: "Daily & weekly reports for Nicaragua's Pacific coast.",
    fr: "Rapports quotidiens et hebdomadaires pour la côte Pacifique du Nicaragua.",
    de: "Tägliche & wöchentliche Berichte für die Pazifikküste Nicaraguas.",
    zh: "尼加拉瓜太平洋海岸的每日和每周报告。",
    it: "Report giornalieri e settimanali per la costa pacifica del Nicaragua.",
    ru: "Ежедневные и еженедельные отчёты для тихоокеанского побережья Nicaragua.",
  },
  install_app: {
    es: "Instalar app",
    en: "Install app",
    fr: "Installer",
    de: "Installieren",
    zh: "安装应用",
    it: "Installa app",
    ru: "Установить приложение",
  },
  menu: {
    es: "Menú",
    en: "Menu",
    fr: "Menu",
    de: "Menü",
    zh: "菜单",
    it: "Menu",
    ru: "Меню",
  },
  close: {
    es: "Cerrar",
    en: "Close",
    fr: "Fermer",
    de: "Schließen",
    zh: "关闭",
    it: "Chiudi",
    ru: "Закрыть",
  },
  login: {
    es: "Entrar",
    en: "Sign in",
    fr: "Connexion",
    de: "Anmelden",
    zh: "登录",
    it: "Accedi",
    ru: "Войти",
  },
  logout: {
    es: "Salir",
    en: "Sign out",
    fr: "Déconnexion",
    de: "Abmelden",
    zh: "退出",
    it: "Esci",
    ru: "Выйти",
  },
  register: {
    es: "Crear cuenta",
    en: "Sign up",
    fr: "Inscription",
    de: "Registrieren",
    zh: "注册",
    it: "Registrati",
    ru: "Зарегистрироваться",
  },
  email: {
    es: "Correo",
    en: "Email",
    fr: "Email",
    de: "E-Mail",
    zh: "电子邮箱",
    it: "Email",
    ru: "Email",
  },
  password: {
    es: "Contraseña",
    en: "Password",
    fr: "Mot de passe",
    de: "Passwort",
    zh: "密码",
    it: "Password",
    ru: "Пароль",
  },
  name: {
    es: "Nombre",
    en: "Name",
    fr: "Nom",
    de: "Name",
    zh: "名称",
    it: "Nome",
    ru: "Имя",
  },
  beach: {
    es: "Playa",
    en: "Beach",
    fr: "Plage",
    de: "Strand",
    zh: "海滩",
    it: "Spiaggia",
    ru: "Пляж",
  },
  today: {
    es: "Hoy",
    en: "Today",
    fr: "Aujourd'hui",
    de: "Heute",
    zh: "今天",
    it: "Oggi",
    ru: "Сегодня",
  },
  week: {
    es: "Semana",
    en: "Week",
    fr: "Semaine",
    de: "Woche",
    zh: "本周",
    it: "Settimana",
    ru: "Неделя",
  },
  surf_report: {
    es: "Reporte de surf",
    en: "Surf report",
    fr: "Rapport surf",
    de: "Surfbericht",
    zh: "冲浪报告",
    it: "Report surf",
    ru: "Сёрф-прогноз",
  },
  weather: {
    es: "Clima",
    en: "Weather",
    fr: "Météo",
    de: "Wetter",
    zh: "天气",
    it: "Meteo",
    ru: "Погода",
  },
  tides: {
    es: "Mareas",
    en: "Tides",
    fr: "Marées",
    de: "Gezeiten",
    zh: "潮汐",
    it: "Maree",
    ru: "Приливы",
  },
  moon: {
    es: "Luna",
    en: "Moon",
    fr: "Lune",
    de: "Mond",
    zh: "月相",
    it: "Luna",
    ru: "Луна",
  },
  alerts: {
    es: "Alertas",
    en: "Alerts",
    fr: "Alertes",
    de: "Warnungen",
    zh: "警报",
    it: "Allerte",
    ru: "Оповещения",
  },
  emergency: {
    es: "Emergencias",
    en: "Emergency",
    fr: "Urgences",
    de: "Notfälle",
    zh: "紧急情况",
    it: "Emergenza",
    ru: "Экстренная помощь",
  },
  chat: {
    es: "Chat comunitario",
    en: "Community chat",
    fr: "Tchat communauté",
    de: "Community-Chat",
    zh: "社区聊天",
    it: "Chat della comunità",
    ru: "Чат сообщества",
  },
  earthquakes: {
    es: "Sismos",
    en: "Earthquakes",
    fr: "Séismes",
    de: "Erdbeben",
    zh: "地震",
    it: "Terremoti",
    ru: "Землетрясения",
  },
  tsunami: {
    es: "Tsunami",
    en: "Tsunami",
    fr: "Tsunami",
    de: "Tsunami",
    zh: "海啸",
    it: "Tsunami",
    ru: "Цунами",
  },
  no_alerts: {
    es: "Sin alertas activas.",
    en: "No active alerts.",
    fr: "Aucune alerte active.",
    de: "Keine aktiven Warnungen.",
    zh: "无有效警报。",
    it: "Nessuna allerta attiva.",
    ru: "Активных оповещений нет.",
  },
  wave_height: {
    es: "Altura ola",
    en: "Wave height",
    fr: "Hauteur de vague",
    de: "Wellenhöhe",
    zh: "浪高",
    it: "Altezza onda",
    ru: "Высота волны",
  },
  wave_period: {
    es: "Período",
    en: "Period",
    fr: "Période",
    de: "Periode",
    zh: "周期",
    it: "Periodo",
    ru: "Период",
  },
  swell_forecast_title: {
    es: "Pronóstico de marejada · 7 días",
    en: "Swell forecast · 7 days",
    fr: "Prévision de houle · 7 jours",
    de: "Wellenvorhersage · 7 Tage",
    zh: "涌浪预报 · 7天",
    it: "Previsione mareggiata · 7 giorni",
    ru: "Прогноз волн · 7 дней",
  },
  swell_forecast_legend: {
    es: "Altura (m) · Período (s)",
    en: "Height (m) · Period (s)",
    fr: "Hauteur (m) · Période (s)",
    de: "Höhe (m) · Periode (s)",
    zh: "高度 (m) · 周期 (s)",
    it: "Altezza (m) · Periodo (s)",
    ru: "Высота (m) · Период (s)",
  },
  wind: {
    es: "Viento",
    en: "Wind",
    fr: "Vent",
    de: "Wind",
    zh: "风",
    it: "Vento",
    ru: "Ветер",
  },
  temp: {
    es: "Temp",
    en: "Temp",
    fr: "Temp",
    de: "Temp",
    zh: "温度",
    it: "Temp",
    ru: "Темп.",
  },
  high: {
    es: "Alta",
    en: "High",
    fr: "Haute",
    de: "Hoch",
    zh: "最高",
    it: "Max",
    ru: "Макс.",
  },
  low: {
    es: "Baja",
    en: "Low",
    fr: "Basse",
    de: "Niedrig",
    zh: "最低",
    it: "Min",
    ru: "Мин.",
  },
  sunrise: {
    es: "Amanecer",
    en: "Sunrise",
    fr: "Lever",
    de: "Sonnenaufgang",
    zh: "日出",
    it: "Alba",
    ru: "Восход",
  },
  sunset: {
    es: "Atardecer",
    en: "Sunset",
    fr: "Coucher",
    de: "Sonnenuntergang",
    zh: "日落",
    it: "Tramonto",
    ru: "Закат",
  },
  next_full_moons: {
    es: "Próximas lunas llenas",
    en: "Next full moons",
    fr: "Prochaines pleines lunes",
    de: "Nächste Vollmonde",
    zh: "接下来的满月",
    it: "Prossime lune piene",
    ru: "Следующие полнолуния",
  },
  illumination: {
    es: "Iluminación",
    en: "Illumination",
    fr: "Illumination",
    de: "Beleuchtung",
    zh: "亮度",
    it: "Illuminazione",
    ru: "Освещённость",
  },
  type_message: {
    es: "Escribe un mensaje…",
    en: "Type a message…",
    fr: "Écrire un message…",
    de: "Nachricht schreiben…",
    zh: "输入消息…",
    it: "Scrivi un messaggio…",
    ru: "Введите сообщение…",
  },
  send: {
    es: "Enviar",
    en: "Send",
    fr: "Envoyer",
    de: "Senden",
    zh: "发送",
    it: "Invia",
    ru: "Отправить",
  },
  login_to_chat: {
    es: "Entra para participar en el chat.",
    en: "Sign in to join the chat.",
    fr: "Connectez-vous pour discuter.",
    de: "Anmelden, um zu chatten.",
    zh: "登录以加入聊天。",
    it: "Accedi per partecipare alla chat.",
    ru: "Войдите, чтобы присоединиться к чату.",
  },
  call: {
    es: "Llamar",
    en: "Call",
    fr: "Appeler",
    de: "Anrufen",
    zh: "呼叫",
    it: "Chiama",
    ru: "Позвонить",
  },
  radar: {
    es: "Radar de lluvia",
    en: "Rain radar",
    fr: "Radar pluie",
    de: "Niederschlagsradar",
    zh: "降雨雷达",
    it: "Radar pioggia",
    ru: "Радар осадков",
  },
  radar_title: {
    es: "Radar meteorológico en vivo",
    en: "Live Doppler-style radar",
    fr: "Radar météo en direct",
    de: "Live-Wetterradar",
    zh: "实时多普勒式雷达",
    it: "Radar Doppler in tempo reale",
    ru: "Доплеровский радар в реальном времени",
  },
  radar_source: {
    es: "Fuente: RainViewer (NOAA / RAINBOW)",
    en: "Source: RainViewer (NOAA / RAINBOW)",
    fr: "Source : RainViewer",
    de: "Quelle: RainViewer",
    zh: "来源: RainViewer (NOAA / RAINBOW)",
    it: "Fonte: RainViewer (NOAA / RAINBOW)",
    ru: "Источник: RainViewer (NOAA / RAINBOW)",
  },
  radar_source_windy: {
    es: "Mapa animado en vivo · Windy.com",
    en: "Live animated map · Windy.com",
    fr: "Carte animée en direct · Windy.com",
    de: "Live-animierte Karte · Windy.com",
    zh: "实时动画地图 · Windy.com",
    it: "Mappa animata in tempo reale · Windy.com",
    ru: "Живая анимированная карта · Windy.com",
  },
  radar_footer_hint: {
    es: "Toca el mapa, reproduce la línea de tiempo y cambia capas para ver tormentas, huracanes y nubes.",
    en: "Tap the map, play the timeline, and switch layers to track storms, hurricanes & clouds.",
    fr: "Touchez la carte, lancez la timeline, changez de couches pour suivre tempêtes, ouragans & nuages.",
    de: "Karte antippen, Timeline starten und Ebenen wechseln, um Stürme, Hurrikane & Wolken zu verfolgen.",
    zh: "安装应用",
    it: "Installa app",
    ru: "Установить приложение",
  },
  radar_footer_hint_short: {
    es: "Toca y cambia capas",
    en: "Tap · switch layers",
    fr: "Toucher · changer",
    de: "Tippen · wechseln",
    zh: "轻点 · 切换图层",
    it: "Tocca · cambia strati",
    ru: "Нажмите · сменить слои",
  },
  fullscreen: {
    es: "Pantalla completa",
    en: "Fullscreen",
    fr: "Plein écran",
    de: "Vollbild",
    zh: "全屏",
    it: "Schermo intero",
    ru: "Полный экран",
  },
  exit_fullscreen: {
    es: "Salir",
    en: "Exit",
    fr: "Quitter",
    de: "Verlassen",
    zh: "退出",
    it: "Esci",
    ru: "Выйти",
  },
  radar_animate: {
    es: "Animar",
    en: "Animate",
    fr: "Animer",
    de: "Animieren",
    zh: "动画",
    it: "Anima",
    ru: "Анимация",
  },
  radar_play_overlay: {
    es: "Reproducir animación",
    en: "Play animation",
    fr: "Lancer l'animation",
    de: "Animation abspielen",
    zh: "播放动画",
    it: "Avvia animazione",
    ru: "Запустить анимацию",
  },
  share: {
    es: "Compartir",
    en: "Share",
    fr: "Partager",
    de: "Teilen",
    zh: "分享",
    it: "Condividi",
    ru: "Поделиться",
  },
  share_radar_title: {
    es: "SJDS Radar Meteorológico",
    en: "SJDS Weather Radar",
    fr: "Radar météo SJDS",
    de: "SJDS Wetterradar",
    zh: "SJDS 天气雷达",
    it: "Radar Meteo SJDS",
    ru: "Погодный радар SJDS",
  },
  share_radar_text: {
    es: "Mira el radar de {layer} en vivo sobre San Juan del Sur en SJDS.app",
    en: "Check the live {layer} radar over San Juan del Sur on SJDS.app",
    fr: "Voir le radar {layer} en direct sur San Juan del Sur sur SJDS.app",
    de: "Live-{layer}-Radar über San Juan del Sur auf SJDS.app ansehen",
    zh: "查看圣胡安德尔苏尔上空的实时 {layer} 雷达，访问 SJDS.app",
    it: "Guarda il radar {layer} in diretta su San Juan del Sur su SJDS.app",
    ru: "Смотрите радар {layer} в прямом эфире над Сан-Хуан-дель-Сур на SJDS.app",
  },
  share_copied: {
    es: "Enlace copiado",
    en: "Link copied",
    fr: "Lien copié",
    de: "Link kopiert",
    zh: "链接已复制",
    it: "Link copiato",
    ru: "Ссылка скопирована",
  },
  share_failed: {
    es: "No se pudo compartir",
    en: "Couldn't share",
    fr: "Partage impossible",
    de: "Teilen fehlgeschlagen",
    zh: "无法分享",
    it: "Impossibile condividere",
    ru: "Не удалось поделиться",
  },
  open_full_map: {
    es: "Ver mapa completo",
    en: "Open full map",
    fr: "Carte complète",
    de: "Vollkarte öffnen",
    zh: "打开完整地图",
    it: "Apri mappa completa",
    ru: "Открыть полную карту",
  },
  layer_satellite: {
    es: "Satélite",
    en: "Satellite",
    fr: "Satellite",
    de: "Satellit",
    zh: "卫星",
    it: "Satellite",
    ru: "Спутник",
  },
  layer_clouds: {
    es: "Nubes",
    en: "Clouds",
    fr: "Nuages",
    de: "Wolken",
    zh: "云",
    it: "Nuvole",
    ru: "Облака",
  },
  layer_rain: {
    es: "Lluvia",
    en: "Rain",
    fr: "Pluie",
    de: "Regen",
    zh: "雨",
    it: "Pioggia",
    ru: "Дождь",
  },
  layer_radar: {
    es: "Radar",
    en: "Radar",
    fr: "Radar",
    de: "Radar",
    zh: "雷达",
    it: "Radar",
    ru: "Радар",
  },
  layer_thunder: {
    es: "Tormentas eléctricas",
    en: "Thunderstorms",
    fr: "Orages",
    de: "Gewitter",
    zh: "雷暴",
    it: "Temporali",
    ru: "Грозы",
  },
  layer_wind: {
    es: "Viento",
    en: "Wind",
    fr: "Vent",
    de: "Wind",
    zh: "风",
    it: "Vento",
    ru: "Ветер",
  },
  layer_gust: {
    es: "Ráfagas",
    en: "Wind gusts",
    fr: "Rafales",
    de: "Böen",
    zh: "阵风",
    it: "Raffiche di vento",
    ru: "Порывы ветра",
  },
  layer_hurricane: {
    es: "Huracanes",
    en: "Hurricanes",
    fr: "Ouragans",
    de: "Hurrikane",
    zh: "飓风",
    it: "Uragani",
    ru: "Ураганы",
  },
  layer_waves: {
    es: "Olas",
    en: "Waves",
    fr: "Vagues",
    de: "Wellen",
    zh: "波浪",
    it: "Onde",
    ru: "Волны",
  },
  layer_swell: {
    es: "Marejada",
    en: "Swell",
    fr: "Houle",
    de: "Dünung",
    zh: "涌浪",
    it: "Moto ondoso",
    ru: "Зыбь",
  },
  layer_swell2: {
    es: "Marejada 2°",
    en: "Secondary swell",
    fr: "Houle 2°",
    de: "2. Dünung",
    zh: "次级涌浪",
    it: "Moto ondoso secondario",
    ru: "Вторичная зыбь",
  },
  layer_wave_period: {
    es: "Período de olas",
    en: "Wave period",
    fr: "Période de vagues",
    de: "Wellenperiode",
    zh: "波周期",
    it: "Periodo dell'onda",
    ru: "Период волны",
  },
  layer_sst: {
    es: "Temperatura del mar",
    en: "Sea surface temp",
    fr: "Temp. de la mer",
    de: "Meerestemperatur",
    zh: "海面温度",
    it: "Temp. sup. mare",
    ru: "Темп. поверхности моря",
  },
  layer_currents: {
    es: "Corrientes",
    en: "Ocean currents",
    fr: "Courants",
    de: "Strömungen",
    zh: "洋流",
    it: "Correnti oceaniche",
    ru: "Океанские течения",
  },
  layer_pressure: {
    es: "Presión",
    en: "Pressure",
    fr: "Pression",
    de: "Druck",
    zh: "气压",
    it: "Pressione",
    ru: "Давление",
  },
  layer_temp: {
    es: "Temperatura",
    en: "Temperature",
    fr: "Température",
    de: "Temperatur",
    zh: "温度",
    it: "Temperatura",
    ru: "Температура",
  },
  layer_humidity: {
    es: "Humedad",
    en: "Humidity",
    fr: "Humidité",
    de: "Luftfeuchte",
    zh: "湿度",
    it: "Umidità",
    ru: "Влажность",
  },
  layer_dewpoint: {
    es: "Punto de rocío",
    en: "Dew point",
    fr: "Point de rosée",
    de: "Taupunkt",
    zh: "露点",
    it: "Punto di rugiada",
    ru: "Точка росы",
  },
  layer_uv: {
    es: "Índice UV",
    en: "UV index",
    fr: "Indice UV",
    de: "UV-Index",
    zh: "紫外线指数",
    it: "Indice UV",
    ru: "УФ-индекс",
  },
  layer_airq: {
    es: "Calidad del aire",
    en: "Air quality",
    fr: "Qualité de l'air",
    de: "Luftqualität",
    zh: "空气质量",
    it: "Qualità dell'aria",
    ru: "Качество воздуха",
  },
  layer_dust: {
    es: "Partículas finas",
    en: "Fine particles",
    fr: "Particules fines",
    de: "Feinstaub",
    zh: "细颗粒物",
    it: "Particelle fini",
    ru: "Мелкие частицы",
  },
  layer_drought: {
    es: "Sequía",
    en: "Drought",
    fr: "Sécheresse",
    de: "Dürre",
    zh: "干旱",
    it: "Siccità",
    ru: "Засуха",
  },
  layer_snow: {
    es: "Nieve",
    en: "Snow",
    fr: "Neige",
    de: "Schnee",
    zh: "雪",
    it: "Neve",
    ru: "Снег",
  },
  layer_visibility: {
    es: "Visibilidad",
    en: "Visibility",
    fr: "Visibilité",
    de: "Sicht",
    zh: "能见度",
    it: "Visibilità",
    ru: "Видимость",
  },
  now: {
    es: "Ahora",
    en: "Now",
    fr: "Maintenant",
    de: "Jetzt",
    zh: "现在",
    it: "Adesso",
    ru: "Сейчас",
  },
  past: {
    es: "Pasado",
    en: "Past",
    fr: "Passé",
    de: "Vergangenheit",
    zh: "过去",
    it: "Passato",
    ru: "Прошлое",
  },
  nowcast: {
    es: "Pronóstico",
    en: "Nowcast",
    fr: "Nowcast",
    de: "Nowcast",
    zh: "临近预报",
    it: "Nowcast",
    ru: "Прогноз на сейчас",
  },
  intensity: {
    es: "Intensidad",
    en: "Intensity",
    fr: "Intensité",
    de: "Intensität",
    zh: "强度",
    it: "Intensità",
    ru: "Интенсивность",
  },
  light: {
    es: "Ligera",
    en: "Light",
    fr: "Légère",
    de: "Leicht",
    zh: "轻",
    it: "Leggero",
    ru: "Слабый",
  },
  moderate: {
    es: "Moderada",
    en: "Moderate",
    fr: "Modérée",
    de: "Mäßig",
    zh: "中",
    it: "Moderato",
    ru: "Умеренный",
  },
  heavy: {
    es: "Fuerte",
    en: "Heavy",
    fr: "Forte",
    de: "Stark",
    zh: "大",
    it: "Forte",
    ru: "Сильный",
  },
  storm: {
    es: "Tormenta",
    en: "Storm",
    fr: "Tempête",
    de: "Sturm",
    zh: "风暴",
    it: "Tempesta",
    ru: "Шторм",
  },
  disclaimer: {
    es: "SJDS.app es una plataforma comunitaria e informativa de clima, surf, mareas y alertas de seguridad para San Juan del Sur y las playas cercanas del Pacífico. No publicamos noticias ni contenido político. En emergencias, siempre contacte a las autoridades oficiales directamente.",
    en: "SJDS.app is an informational community weather, surf, tide, and safety-alert platform for San Juan del Sur and nearby Pacific beaches. We do not publish news or political content. For emergencies, always contact official authorities directly.",
    fr: "SJDS.app est une plateforme communautaire d'information sur la météo, le surf, les marées et les alertes de sécurité pour San Juan del Sur et les plages du Pacifique. Nous ne publions pas d'actualités ni de contenu politique. En cas d'urgence, contactez toujours directement les autorités officielles.",
    de: "SJDS.app ist eine informative Community-Plattform für Wetter, Surf, Gezeiten und Sicherheitswarnungen für San Juan del Sur und die nahegelegenen Pazifikstrände. Wir veröffentlichen weder Nachrichten noch politische Inhalte. Bei Notfällen wenden Sie sich immer direkt an die offiziellen Behörden.",
    zh: "链接已复制",
    it: "Link copiato",
    ru: "Ссылка скопирована",
  },
  admin_post: {
    es: "Publicar alerta",
    en: "Post alert",
    fr: "Publier une alerte",
    de: "Warnung posten",
    zh: "发布警报",
    it: "Pubblica allerta",
    ru: "Опубликовать оповещение",
  },
  alert_title: {
    es: "Título",
    en: "Title",
    fr: "Titre",
    de: "Titel",
    zh: "标题",
    it: "Titolo",
    ru: "Заголовок",
  },
  alert_body: {
    es: "Mensaje",
    en: "Message",
    fr: "Message",
    de: "Nachricht",
    zh: "内容",
    it: "Messaggio",
    ru: "Сообщение",
  },
  severity: {
    es: "Severidad",
    en: "Severity",
    fr: "Sévérité",
    de: "Schwere",
    zh: "严重性",
    it: "Gravità",
    ru: "Серьёзность",
  },
  info: {
    es: "Info",
    en: "Info",
    fr: "Info",
    de: "Info",
    zh: "信息",
    it: "Info",
    ru: "Инфо",
  },
  warning: {
    es: "Aviso",
    en: "Warning",
    fr: "Avertissement",
    de: "Warnung",
    zh: "警告",
    it: "Avviso",
    ru: "Предупреждение",
  },
  from_sjds: {
    es: "de SJDS",
    en: "from SJDS",
    fr: "de SJDS",
    de: "von SJDS",
    zh: "来自 SJDS",
    it: "da SJDS",
    ru: "от SJDS",
  },
  loading_surf: {
    es: "Cargando surf y clima…",
    en: "Loading surf & weather…",
    fr: "Chargement surf & météo…",
    de: "Lade Surf & Wetter…",
    zh: "发布警报",
    it: "Pubblica avviso",
    ru: "Опубликовать оповещение",
  },
  sessions_eyebrow: {
    es: "Comunidad",
    en: "Community",
    fr: "Communauté",
    de: "Community",
    zh: "社区",
    it: "Comunità",
    ru: "Сообщество",
  },
  sessions_title: {
    es: "Sesiones de surf",
    en: "Surf sessions",
    fr: "Sessions de surf",
    de: "Surf-Sessions",
    zh: "冲浪活动",
    it: "Sessioni di surf",
    ru: "Сёрф-сессии",
  },
  sessions_subtitle: {
    es: "Publica tu plan de surf y deja que otros se unan.",
    en: "Post your surf plan and let others join in.",
    fr: "Publiez votre plan de surf et laissez les autres vous rejoindre.",
    de: "Poste deinen Surf-Plan und lass andere mitsurfen.",
    zh: "社区",
    it: "Comunità",
    ru: "Сообщество",
  },
  sessions_empty: {
    es: "Aún no hay sesiones programadas. ¡Sé el primero en publicar una!",
    en: "No sessions scheduled yet. Be the first to post one!",
    fr: "Aucune session prévue. Soyez le premier !",
    de: "Noch keine Sessions geplant. Sei der Erste!",
    zh: "尚无已安排的活动。成为第一个发布活动的人！",
    it: "Nessuna sessione ancora programmata. Sii il primo a pubblicarne una!",
    ru: "Запланированных сессий пока нет. Станьте первым, кто её опубликует!",
  },
  session_new: {
    es: "Nueva sesión",
    en: "New session",
    fr: "Nouvelle session",
    de: "Neue Session",
    zh: "新建活动",
    it: "Nuova sessione",
    ru: "Новая сессия",
  },
  session_create: {
    es: "Publicar",
    en: "Post session",
    fr: "Publier",
    de: "Veröffentlichen",
    zh: "发布活动",
    it: "Pubblica sessione",
    ru: "Опубликовать сессию",
  },
  session_join: {
    es: "Unirme",
    en: "Join",
    fr: "Rejoindre",
    de: "Beitreten",
    zh: "加入",
    it: "Partecipa",
    ru: "Присоединиться",
  },
  session_leave: {
    es: "Salir",
    en: "Leave",
    fr: "Quitter",
    de: "Verlassen",
    zh: "离开",
    it: "Lascia",
    ru: "Покинуть",
  },
  session_full: {
    es: "Lleno",
    en: "Full",
    fr: "Complet",
    de: "Voll",
    zh: "已满",
    it: "Completo",
    ru: "Мест нет",
  },
  session_delete: {
    es: "Eliminar",
    en: "Delete",
    fr: "Supprimer",
    de: "Löschen",
    zh: "删除",
    it: "Elimina",
    ru: "Удалить",
  },
  session_delete_confirm: {
    es: "¿Eliminar esta sesión?",
    en: "Delete this session?",
    fr: "Supprimer cette session ?",
    de: "Diese Session löschen?",
    zh: "删除此活动？",
    it: "Eliminare questa sessione?",
    ru: "Удалить эту сессию?",
  },
  session_date: {
    es: "Día",
    en: "Date",
    fr: "Date",
    de: "Datum",
    zh: "日期",
    it: "Data",
    ru: "Дата",
  },
  session_time: {
    es: "Hora",
    en: "Time",
    fr: "Heure",
    de: "Zeit",
    zh: "时间",
    it: "Ora",
    ru: "Время",
  },
  session_max: {
    es: "Máx",
    en: "Max",
    fr: "Max",
    de: "Max",
    zh: "最多",
    it: "Max",
    ru: "Макс.",
  },
  session_note_placeholder: {
    es: "ej. Dawn patrol en Maderas, café después. ¡Únanse!",
    en: "e.g. Dawn patrol at Maderas, coffee after. Come join!",
    fr: "ex. Dawn patrol à Maderas, café après. Rejoignez !",
    de: "z.B. Dawn Patrol an Maderas, Kaffee danach. Komm mit!",
    zh: "新活动",
    it: "Nuova sessione",
    ru: "Новая сессия",
  },
  session_signin_to_join: {
    es: "Entra para unirte.",
    en: "Sign in to join.",
    fr: "Connectez-vous pour rejoindre.",
    de: "Anmelden, um mitzumachen.",
    zh: "登录以加入。",
    it: "Accedi per partecipare.",
    ru: "Войдите, чтобы присоединиться.",
  },
  session_signin_to_post: {
    es: "Entra para publicar",
    en: "Sign in to post",
    fr: "Connexion pour publier",
    de: "Anmelden zum Posten",
    zh: "登录以发布",
    it: "Accedi per pubblicare",
    ru: "Войдите, чтобы опубликовать",
  },
  help_community_eyebrow: {
    es: "Comunidad",
    en: "Community",
    fr: "Communauté",
    de: "Community",
    zh: "社区",
    it: "Comunità",
    ru: "Сообщество",
  },
  help_community_title: {
    es: "Ayuda a la comunidad",
    en: "Help the Community",
    fr: "Aidez la communauté",
    de: "Hilf der Gemeinde",
    zh: "帮助社区",
    it: "Aiuta la Comunità",
    ru: "Помогите Сообществу",
  },
  help_community_subtitle: {
    es: "Apoya a las fundaciones de San Juan del Sur que cuidan a nuestra gente y a nuestros animales.",
    en: "Support the San Juan del Sur foundations that care for our people and our animals.",
    fr: "Soutenez les fondations de San Juan del Sur qui prennent soin de notre communauté.",
    de: "Unterstütze die Stiftungen von San Juan del Sur, die sich um unsere Menschen und Tiere kümmern.",
    zh: "登录以加入。",
    it: "Accedi per partecipare.",
    ru: "Войдите, чтобы присоединиться.",
  },
  help_community_footer_note: {
    es: "Las donaciones van directamente a cada organización. SJDS.app no recibe ninguna comisión.",
    en: "Donations go directly to each organization. SJDS.app takes no cut.",
    fr: "Les dons vont directement à chaque organisation. SJDS.app ne prend aucune commission.",
    de: "Spenden gehen direkt an jede Organisation. SJDS.app behält keine Gebühr ein.",
    zh: "捐款将直接捐给各个组织。SJDS.app 不收取任何费用。",
    it: "Le donazioni vanno direttamente a ciascuna organizzazione. SJDS.app non trattiene alcuna commissione.",
    ru: "Пожертвования поступают напрямую в каждую организацию. SJDS.app не берёт комиссию.",
  },
  np_donate: {
    es: "Donar",
    en: "Donate",
    fr: "Faire un don",
    de: "Spenden",
    zh: "捐赠",
    it: "Dona",
    ru: "Пожертвовать",
  },
  np_visit: {
    es: "Visitar sitio",
    en: "Visit site",
    fr: "Voir le site",
    de: "Webseite",
    zh: "访问网站",
    it: "Visita il sito",
    ru: "Посетить сайт",
  },
  np_curious_badge: {
    es: "Educación · Niños",
    en: "Education · Kids",
    fr: "Éducation · Enfants",
    de: "Bildung · Kinder",
    zh: "教育 · 儿童",
    it: "Istruzione · Bambini",
    ru: "Образование · Дети",
  },
  np_curious_tagline: {
    es: "Programa de educación y mentoría que despierta la curiosidad y abre oportunidades para niños y jóvenes de San Juan del Sur.",
    en: "Education and mentorship that sparks curiosity and opens opportunities for kids and youth in San Juan del Sur.",
    fr: "Éducation et mentorat qui éveillent la curiosité et ouvrent des opportunités aux enfants de San Juan del Sur.",
    de: "Bildung und Mentoring, das die Neugier weckt und Chancen für Kinder und Jugendliche in San Juan del Sur eröffnet.",
    zh: "捐赠",
    it: "Istruzione e tutoraggio che accendono la curiosità e aprono opportunità per bambini e giovani a San Juan del Sur.",
    ru: "Пожертвовать",
  },
  np_sos_badge: {
    es: "Rescate animal",
    en: "Animal rescue",
    fr: "Sauvetage animal",
    de: "Tierrettung",
    zh: "动物救援",
    it: "Soccorso animali",
    ru: "Спасение животных",
  },
  np_sos_tagline: {
    es: "Rescate, esterilización y atención veterinaria para perros y gatos callejeros en la región de SJDS.",
    en: "Rescue, sterilization, and vet care for the street dogs and cats of the SJDS area.",
    fr: "Sauvetage, stérilisation et soins vétérinaires pour les chiens et chats des rues de SJDS.",
    de: "Rettung, Sterilisation und tierärztliche Versorgung für Straßenhunde und -katzen rund um SJDS.",
    zh: "动物救援",
    it: "Soccorso animali",
    ru: "Спасение животных",
  },
  np_elis_badge: {
    es: "Conservación de ballenas",
    en: "Whale conservation",
    fr: "Conservation des baleines",
    de: "Walschutz",
    zh: "鲸鱼保护",
    it: "Conservazione delle balene",
    ru: "Сохранение китов",
  },
  np_elis_tagline: {
    es: "Investigación, protección y educación sobre ballenas y delfines en el Pacífico de Nicaragua — ciencia marina liderada desde San Juan del Sur.",
    en: "Whale and dolphin research, protection, and education along Nicaragua's Pacific coast — marine science led from San Juan del Sur.",
    fr: "Recherche, protection et éducation sur les baleines et dauphins du Pacifique nicaraguayen — science marine basée à San Juan del Sur.",
    de: "Wal- und Delfinforschung, Schutz und Bildung an Nicaraguas Pazifikküste — Meereswissenschaft aus San Juan del Sur.",
    zh: "鲸鱼保护",
    it: "Conservazione delle balene",
    ru: "Сохранение китов",
  },
  np_believe_badge: {
    es: "Educación bilingüe",
    en: "Bilingual education",
    fr: "Éducation bilingue",
    de: "Zweisprachige Bildung",
    zh: "双语教育",
    it: "Educazione bilingue",
    ru: "Двуязычное образование",
  },
  np_believe_tagline: {
    es: "Educación bilingüe y formación integral para niñas y niños de San Juan del Sur — invertir en la próxima generación de Nicaragua.",
    en: "Bilingual education and whole-child development for kids in San Juan del Sur — investing in Nicaragua's next generation.",
    fr: "Éducation bilingue et développement global pour les enfants de San Juan del Sur — investir dans la prochaine génération du Nicaragua.",
    de: "Zweisprachige Bildung und ganzheitliche Förderung für Kinder in San Juan del Sur — Investition in Nicaraguas nächste Generation.",
    zh: "双语教育",
    it: "Educazione bilingue",
    ru: "Двуязычное образование",
  },
  np_brugger_badge: {
    es: "Comunidad · Bienestar",
    en: "Community · Wellbeing",
    fr: "Communauté · Bien-être",
    de: "Gemeinschaft · Wohl",
    zh: "社区 · 福祉",
    it: "Comunità · Benessere",
    ru: "Сообщество · Благополучие",
  },
  np_brugger_tagline: {
    es: "Programas comunitarios que apoyan a familias, jóvenes y proyectos sociales en Nicaragua.",
    en: "Community programs supporting families, youth, and social projects across Nicaragua.",
    fr: "Programmes communautaires soutenant les familles, les jeunes et les projets sociaux au Nicaragua.",
    de: "Gemeinschaftsprogramme zur Unterstützung von Familien, Jugendlichen und sozialen Projekten in Nicaragua.",
    zh: "社区 · 福祉",
    it: "Comunità · Benessere",
    ru: "Сообщество · Благополучие",
  },
  live_nicaragua: {
    es: "En vivo · Nicaragua",
    en: "Live · Nicaragua",
    fr: "En direct · Nicaragua",
    de: "Live · Nicaragua",
    zh: "直播 · Nicaragua",
    it: "In diretta · Nicaragua",
    ru: "Прямой эфир · Nicaragua",
  },
  nav_home: {
    es: "Inicio",
    en: "Home",
    fr: "Accueil",
    de: "Start",
    zh: "首页",
    it: "Home",
    ru: "Главная",
  },
  nav_history: {
    es: "Historia",
    en: "History",
    fr: "Histoire",
    de: "Geschichte",
    zh: "历史",
    it: "Storia",
    ru: "История",
  },
  nav_weather: {
    es: "Clima",
    en: "Weather",
    fr: "Météo",
    de: "Wetter",
    zh: "天气",
    it: "Meteo",
    ru: "Погода",
  },
  nav_surf: {
    es: "Surf",
    en: "Surf",
    fr: "Surf",
    de: "Surf",
    zh: "冲浪",
    it: "Surf",
    ru: "Сёрф",
  },
  nav_beaches: {
    es: "Playas",
    en: "Beaches",
    fr: "Plages",
    de: "Strände",
    zh: "海滩",
    it: "Spiagge",
    ru: "Пляжи",
  },
  nav_community: {
    es: "Comunidad",
    en: "Community",
    fr: "Communauté",
    de: "Gemeinschaft",
    zh: "社区",
    it: "Comunità",
    ru: "Сообщество",
  },
  nav_profile: {
    es: "Perfil",
    en: "Profile",
    fr: "Profil",
    de: "Profil",
    zh: "个人资料",
    it: "Profilo",
    ru: "Профиль",
  },
  nav_admin: {
    es: "Admin",
    en: "Admin",
    fr: "Admin",
    de: "Admin",
    zh: "管理",
    it: "Admin",
    ru: "Админ",
  },
  nav_taxi: {
    es: "Nicaragua Taxi",
    en: "Nicaragua Taxi",
    fr: "Nicaragua Taxi",
    de: "Nicaragua Taxi",
    zh: "尼加拉瓜出租车",
    it: "Nicaragua Taxi",
    ru: "Никарагуа Такси",
  },
  nav_locals: { es: "Locales SJDS", en: "SJDS Locals", fr: "Locaux SJDS", de: "SJDS Einheimische", zh: "SJDS 本地", it: "Locali SJDS", ru: "Локальные SJDS" },
  nav_blog: { es: "Blog", en: "Blog", fr: "Blog", de: "Blog", zh: "博客", it: "Blog", ru: "Блог" },
  locals_hero_eyebrow: { es: "Comunidad · San Juan del Sur", en: "Community · San Juan del Sur", fr: "Communauté · San Juan del Sur", de: "Community · San Juan del Sur", zh: "社区 · 圣胡安德尔苏尔", it: "Comunità · San Juan del Sur", ru: "Сообщество · Сан-Хуан-дель-Сур" },
  locals_hero_title: { es: "Locales SJDS", en: "SJDS Locals", fr: "Locaux SJDS", de: "SJDS Einheimische", zh: "SJDS 本地", it: "Locali di SJDS", ru: "Местные SJDS" },
  locals_hero_subtitle: {
    es: "Tu hub para chat comunitario, negocios locales, transporte y más en San Juan del Sur. Cualquiera puede explorar; inicia sesión para participar.",
    en: "Your hub for community chat, local businesses, transportation and more in San Juan del Sur. Anyone can browse; sign in to take part.",
    fr: "Votre plateforme pour le chat communautaire, les commerces locaux, le transport et plus à San Juan del Sur. Tout le monde peut consulter ; connectez-vous pour participer.",
    de: "Dein Hub für Community-Chat, lokale Unternehmen, Transport und mehr in San Juan del Sur. Jeder kann stöbern; melde dich an, um mitzumachen.",
    zh: "圣胡安德尔苏尔的社区聊天、本地商家、交通等中心。任何人都可以浏览；登录后即可参与。",
    it: "Il tuo hub per chat di comunità, attività locali, trasporti e altro a San Juan del Sur. Chiunque può sfogliare; accedi per partecipare.",
    ru: "Ваш центр чата сообщества, местных компаний, транспорта и многого другого в Сан-Хуан-дель-Сур. Любой может просматривать; войдите, чтобы участвовать.",
  },
  locals_chat_eyebrow: { es: "Chat en vivo", en: "Live chat", fr: "Chat en direct", de: "Live-Chat", zh: "实时聊天", it: "Chat dal vivo", ru: "Живой чат" },
  locals_chat_title: { es: "Chat comunitario", en: "Community chat", fr: "Chat communautaire", de: "Community-Chat", zh: "社区聊天", it: "Chat della comunità", ru: "Чат сообщества" },
  locals_chat_subtitle: {
    es: "Cualquiera puede leer. Inicia sesión para chatear con locales y viajeros en tiempo real.",
    en: "Anyone can read. Sign in to chat with locals and travelers in real time.",
    fr: "Tout le monde peut lire. Connectez-vous pour discuter avec locaux et voyageurs en temps réel.",
    de: "Jeder kann lesen. Melde dich an, um in Echtzeit mit Einheimischen und Reisenden zu chatten.",
    zh: "任何人都可阅读。登录后即可与本地人和旅行者实时聊天。",
    it: "Chiunque può leggere. Accedi per chattare con locali e viaggiatori in tempo reale.",
    ru: "Любой может читать. Войдите, чтобы общаться с местными и путешественниками в реальном времени.",
  },
  locals_biz_eyebrow: { es: "Negocios locales", en: "Local businesses", fr: "Commerces locaux", de: "Lokale Unternehmen", zh: "本地商家", it: "Attività locali", ru: "Местные бизнесы" },
  locals_biz_title: { es: "Apoya a SJDS", en: "Support SJDS", fr: "Soutenez SJDS", de: "Unterstütze SJDS", zh: "支持 SJDS", it: "Sostieni SJDS", ru: "Поддержите SJDS" },
  locals_biz_subtitle: {
    es: "Sitios web de aliados locales que hemos construido en San Juan del Sur.",
    en: "Local partner sites we've built in San Juan del Sur.",
    fr: "Sites de partenaires locaux que nous avons construits à San Juan del Sur.",
    de: "Lokale Partner-Websites, die wir in San Juan del Sur erstellt haben.",
    zh: "我们在圣胡安德尔苏尔为本地合作伙伴搭建的网站。",
    it: "Siti di partner locali che abbiamo costruito a San Juan del Sur.",
    ru: "Сайты местных партнёров, которые мы создали в Сан-Хуан-дель-Сур.",
  },
  locals_biz_add: { es: "Sugerir negocio", en: "Suggest a business", fr: "Suggérer un commerce", de: "Unternehmen vorschlagen", zh: "推荐商家", it: "Suggerisci un'attività", ru: "Предложить бизнес" },
  locals_biz_signin_to_add: { es: "Inicia sesión para agregar", en: "Sign in to add", fr: "Connectez-vous pour ajouter", de: "Anmelden zum Hinzufügen", zh: "登录以添加", it: "Accedi per aggiungere", ru: "Войдите, чтобы добавить" },
  locals_taxi_eyebrow: { es: "Transporte", en: "Transportation", fr: "Transport", de: "Transport", zh: "交通", it: "Trasporti", ru: "Транспорт" },
  locals_taxi_title: { es: "Nicaragua Taxi Services", en: "Nicaragua Taxi Services", fr: "Nicaragua Taxi Services", de: "Nicaragua Taxi Services", zh: "Nicaragua Taxi Services", it: "Nicaragua Taxi Services", ru: "Nicaragua Taxi Services" },
  locals_taxi_subtitle: {
    es: "Aliado oficial de transporte privado de SJDS.app.",
    en: "Official private transportation partner of SJDS.app.",
    fr: "Partenaire officiel de transport privé de SJDS.app.",
    de: "Offizieller privater Transportpartner von SJDS.app.",
    zh: "SJDS.app 官方私人交通合作伙伴。",
    it: "Partner ufficiale di trasporto privato di SJDS.app.",
    ru: "Официальный партнёр SJDS.app по частному транспорту.",
  },
  locals_cs_eyebrow: { es: "Próximamente", en: "Coming soon", fr: "Bientôt disponible", de: "Demnächst", zh: "即将推出", it: "Prossimamente", ru: "Скоро" },
  locals_cs_title: { es: "Más para Locales SJDS", en: "More for SJDS Locals", fr: "Plus pour les Locaux SJDS", de: "Mehr für SJDS Einheimische", zh: "更多 SJDS 本地内容", it: "Altro per i Locali SJDS", ru: "Больше для местных SJDS" },
  locals_cs_subtitle: {
    es: "Funciones que estamos construyendo. ¿Tienes una idea? ¡Envíala!",
    en: "Features we're building. Got an idea? Send it in!",
    fr: "Fonctionnalités en construction. Vous avez une idée ? Envoyez-la !",
    de: "Funktionen, die wir bauen. Idee? Schick sie ein!",
    zh: "我们正在构建的功能。有想法？告诉我们！",
    it: "Funzionalità in arrivo. Hai un'idea? Inviala!",
    ru: "Функции, которые мы строим. Есть идея? Присылайте!",
  },
  locals_coming_soon: { es: "Próximamente", en: "Coming soon", fr: "Bientôt", de: "Demnächst", zh: "即将推出", it: "In arrivo", ru: "Скоро" },
  locals_cs_directory_title: { es: "Directorio de locales", en: "Locals directory", fr: "Répertoire des locaux", de: "Verzeichnis der Einheimischen", zh: "本地人名录", it: "Elenco dei locali", ru: "Справочник местных" },
  locals_cs_directory_desc: { es: "Encuentra y contacta residentes — instructores de surf, chefs, agentes, terapeutas y más.", en: "Find and reach out to residents — surf instructors, chefs, agents, therapists & more.", fr: "Trouvez et contactez des résidents — instructeurs de surf, chefs, agents, thérapeutes et plus.", de: "Finde und kontaktiere Einheimische — Surflehrer, Köche, Makler, Therapeuten & mehr.", zh: "查找并联系居民——冲浪教练、厨师、经纪人、治疗师等。", it: "Trova e contatta i residenti — istruttori di surf, chef, agenti, terapisti e altro.", ru: "Найдите и свяжитесь с местными — инструкторами серфинга, шеф-поварами, агентами, терапевтами и др." },
  locals_cs_buy_sell_title: { es: "Compra y venta SJDS", en: "Buy & sell SJDS", fr: "Achat & vente SJDS", de: "Kaufen & verkaufen SJDS", zh: "SJDS 二手买卖", it: "Compra & vendi SJDS", ru: "Купля и продажа SJDS" },
  locals_cs_buy_sell_desc: { es: "Tablero local para tablas de surf, muebles, motos, autos y herramientas.", en: "Local board for surfboards, furniture, motos, cars and tools.", fr: "Tableau local pour planches, meubles, motos, voitures et outils.", de: "Lokales Board für Surfboards, Möbel, Motorräder, Autos und Werkzeuge.", zh: "冲浪板、家具、摩托、汽车与工具的本地交易板。", it: "Bacheca locale per tavole da surf, mobili, moto, auto e attrezzi.", ru: "Локальная доска для досок для серфинга, мебели, мотоциклов, машин и инструментов." },
  locals_cs_events_title: { es: "Eventos y recaudaciones", en: "Events & fundraisers", fr: "Événements & collectes", de: "Veranstaltungen & Spenden", zh: "活动与募款", it: "Eventi & raccolte", ru: "События и сборы" },
  locals_cs_events_desc: { es: "Calendario mensual de eventos comunitarios y fondos benéficos.", en: "Monthly calendar of community events and charity drives.", fr: "Calendrier mensuel des événements communautaires et collectes.", de: "Monatlicher Kalender für Community-Events und Spendenaktionen.", zh: "每月社区活动与慈善募款日历。", it: "Calendario mensile di eventi comunitari e raccolte fondi.", ru: "Ежемесячный календарь общественных мероприятий и благотворительных акций." },
  locals_cs_features_title: { es: "Conoce a los locales", en: "Meet the locals", fr: "Rencontrez les locaux", de: "Lerne die Einheimischen kennen", zh: "认识本地人", it: "Conosci i locali", ru: "Познакомьтесь с местными" },
  locals_cs_features_desc: { es: "Historias destacadas de personas que dan vida a SJDS.", en: "Feature stories on the people who make SJDS what it is.", fr: "Portraits des personnes qui font de SJDS ce qu'il est.", de: "Reportagen über die Menschen, die SJDS prägen.", zh: "讲述构成 SJDS 这座小城的人们的故事。", it: "Storie speciali sulle persone che rendono SJDS ciò che è.", ru: "Очерки о людях, которые делают SJDS таким, какой он есть." },
  locals_suggest_idea: { es: "Sugerir una idea", en: "Suggest an idea", fr: "Suggérer une idée", de: "Idee vorschlagen", zh: "提出想法", it: "Suggerisci un'idea", ru: "Предложить идею" },
  nicaragua_taxi_tagline: {
    es: "Transporte privado confiable en San Juan del Sur y toda Nicaragua.",
    en: "Reliable private transportation around San Juan del Sur and across Nicaragua.",
    fr: "Transport privé fiable à San Juan del Sur et dans tout le Nicaragua.",
    de: "Zuverlässiger Privattransport in San Juan del Sur und ganz Nicaragua.",
    zh: "圣胡安德尔苏尔及尼加拉瓜全国可靠的私人交通服务。",
    it: "Trasporto privato affidabile a San Juan del Sur e in tutto il Nicaragua.",
    ru: "Надёжные частные перевозки в Сан-Хуан-дель-Сур и по всей Никарагуа.",
  },

  /* History teaser + page chrome */
  history_eyebrow: {
    es: "Archivo · SJDS",
    en: "Archive · SJDS",
    fr: "Archives · SJDS",
    de: "Archiv · SJDS",
    zh: "存档 · SJDS",
    it: "Archivio · SJDS",
    ru: "Архив · SJDS",
  },
  history_title: {
    es: "La historia de San Juan del Sur",
    en: "The History of San Juan del Sur",
    fr: "L'histoire de San Juan del Sur",
    de: "Die Geschichte von San Juan del Sur",
    zh: "San Juan del Sur 的历史",
    it: "La Storia di San Juan del Sur",
    ru: "История San Juan del Sur",
  },
  history_subtitle: {
    es: "Del pueblo pesquero indígena al portal de la Fiebre del Oro y el alma surfista de la costa Pacífica de Nicaragua. Fotos, historias y capítulos del archivo.",
    en: "From indigenous fishing village to Gold-Rush gateway and surf-town soul of Nicaragua's Pacific coast. Photos, stories, and chapters from the archive.",
    fr: "Du village de pêcheurs autochtones à la porte de la Ruée vers l'Or et à l'âme surf de la côte Pacifique du Nicaragua. Photos, histoires et chapitres des archives.",
    de: "Vom indigenen Fischerdorf zum Tor des Goldrauschs und zur Surf-Town-Seele der Pazifikküste Nicaraguas. Fotos, Geschichten und Kapitel aus dem Archiv.",
    zh: "现场 · Nicaragua",
    it: "In diretta · Nicaragua",
    ru: "Вживую · Nicaragua",
  },
  history_cta: {
    es: "Leer la historia de San Juan del Sur",
    en: "Read the History of San Juan del Sur",
    fr: "Lire l'histoire de San Juan del Sur",
    de: "Die Geschichte von San Juan del Sur lesen",
    zh: "阅读 San Juan del Sur 的历史",
    it: "Leggi la Storia di San Juan del Sur",
    ru: "Читать историю San Juan del Sur",
  },
  history_in_archive: {
    es: "En este archivo",
    en: "In this archive",
    fr: "Dans ces archives",
    de: "In diesem Archiv",
    zh: "在此存档中",
    it: "In questo archivio",
    ru: "В этом архиве",
  },
  history_more_soon: {
    es: "Próximamente más capítulos e imágenes históricas — comparte las tuyas etiquetando #SJDSapp o escribiendo al administrador en el chat comunitario.",
    en: "More chapters and historic photos coming soon — share yours by tagging #SJDSapp or messaging the admin in the community chat.",
    fr: "Plus de chapitres et de photos historiques à venir — partagez les vôtres en taguant #SJDSapp ou en écrivant à l'administrateur dans le chat communautaire.",
    de: "Bald folgen weitere Kapitel und historische Fotos — teile deine, indem du #SJDSapp markierst oder den Administrator im Community-Chat anschreibst.",
    zh: "阅读 San Juan del Sur 的历史",
    it: "Leggi la Storia di San Juan del Sur",
    ru: "Прочитать Историю San Juan del Sur",
  },
  history_lang_note: {
    es: "",
    en: "",
    fr: "",
    de: "",
    zh: "",
    it: "",
    ru: "",
  },

  /* History article titles */
  hist_overview_title: {
    es: "La historia de San Juan del Sur, Nicaragua",
    en: "The History of San Juan del Sur, Nicaragua",
    fr: "L'histoire de San Juan del Sur, Nicaragua",
    de: "Die Geschichte von San Juan del Sur, Nicaragua",
    zh: "Nicaragua, San Juan del Sur 的历史",
    it: "La Storia di San Juan del Sur, Nicaragua",
    ru: "История San Juan del Sur, Nicaragua",
  },
  hist_maderas_title: {
    es: "La historia de Playa Maderas",
    en: "The History of Playa Maderas",
    fr: "L'histoire de Playa Maderas",
    de: "Die Geschichte von Playa Maderas",
    zh: "Playa Maderas 的历史",
    it: "La Storia di Playa Maderas",
    ru: "История Playa Maderas",
  },
  hist_remanso_title: {
    es: "La historia de Playa Remanso",
    en: "The History of Playa Remanso",
    fr: "L'histoire de Playa Remanso",
    de: "Die Geschichte von Playa Remanso",
    zh: "Playa Remanso 的历史",
    it: "La Storia di Playa Remanso",
    ru: "История Playa Remanso",
  },
  hist_hermosa_title: {
    es: "La historia de Playa Hermosa",
    en: "The History of Playa Hermosa",
    fr: "L'histoire de Playa Hermosa",
    de: "Die Geschichte von Playa Hermosa",
    zh: "Playa Hermosa 的历史",
    it: "La Storia di Playa Hermosa",
    ru: "История Playa Hermosa",
  },
  hist_laflor_title: {
    es: "La historia de Playa La Flor",
    en: "The History of Playa La Flor",
    fr: "L'histoire de Playa La Flor",
    de: "Die Geschichte von Playa La Flor",
    zh: "Playa La Flor 的历史",
    it: "La Storia di Playa La Flor",
    ru: "История Playa La Flor",
  },
  hist_cristo_title: {
    es: "Cristo de la Misericordia",
    en: "Cristo de la Misericordia",
    fr: "Cristo de la Misericordia",
    de: "Cristo de la Misericordia",
    zh: "Cristo de la Misericordia（仁慈基督像）",
    it: "Cristo de la Misericordia",
    ru: "Cristo de la Misericordia (Христос Милосердия)",
  },
  hist_goldrush_title: {
    es: "La conexión con la Fiebre del Oro de California",
    en: "The California Gold Rush Connection",
    fr: "Le lien avec la Ruée vers l'Or californienne",
    de: "Die Verbindung zum kalifornischen Goldrausch",
    zh: "与加州淘金热的渊源",
    it: "Il legame con la corsa all'oro californiana",
    ru: "Связь с Калифорнийской золотой лихорадкой",
  },

  /* Nicaragua Taxi CTA */
  taxi_eyebrow: {
    es: "Partner · Transporte",
    en: "Partner · Transportation",
    fr: "Partenaire · Transport",
    de: "Partner · Transport",
    zh: "合作伙伴 · 交通",
    it: "Partner · Trasporti",
    ru: "Партнёр · Транспорт",
  },
  taxi_headline: {
    es: "¿Necesitas un viaje hacia o desde San Juan del Sur?",
    en: "Need a ride to or from San Juan del Sur?",
    fr: "Besoin d'un trajet vers ou depuis San Juan del Sur ?",
    de: "Brauchst du eine Fahrt nach oder von San Juan del Sur?",
    zh: "Nicaragua, San Juan del Sur 的历史",
    it: "La Storia di San Juan del Sur, Nicaragua",
    ru: "История San Juan del Sur, Nicaragua",
  },
  taxi_body: {
    es: "Servicios de taxi y traslados seguros y confiables en toda Nicaragua — traslados al aeropuerto, salto de playas, cruces fronterizos y viajes de larga distancia con conductores locales amables.",
    en: "Safe, reliable taxi & shuttle services across Nicaragua — airport transfers, beach hopping, border runs, and long-distance travel with friendly local drivers.",
    fr: "Services de taxi et de navettes fiables et sûrs à travers le Nicaragua — transferts aéroport, plages, frontières et longs trajets avec des chauffeurs locaux sympathiques.",
    de: "Sichere, zuverlässige Taxi- und Shuttle-Services in ganz Nicaragua — Flughafentransfer, Strandhopping, Grenzfahrten und Langstrecken mit freundlichen lokalen Fahrern.",
    zh: "在 Nicaragua 各地提供安全可靠的出租车和班车服务 — 机场接送、海滩游览、边境往返以及由友好的当地司机提供的长途旅行。",
    it: "Servizi taxi e navetta sicuri e affidabili in tutto il Nicaragua — transfer aeroportuali, tour delle spiagge, corse al confine e viaggi a lunga distanza con autisti locali amichevoli.",
    ru: "Безопасные и надёжные услуги такси и шаттлов по всей Nicaragua — трансферы из аэропорта, поездки по пляжам, пересечение границы и дальние поездки с дружелюбными местными водителями.",
  },
  taxi_f1: {
    es: "Traslados al aeropuerto",
    en: "Airport transfers",
    fr: "Transferts aéroport",
    de: "Flughafentransfer",
    zh: "机场接送",
    it: "Trasferimenti aeroportuali",
    ru: "Трансферы в аэропорт",
  },
  taxi_f2: {
    es: "Saltar entre playas",
    en: "Beach hopping",
    fr: "Plages en chaîne",
    de: "Strandhopping",
    zh: "海滩游",
    it: "Tour delle spiagge",
    ru: "Поездки по пляжам",
  },
  taxi_f3: {
    es: "Cruces fronterizos",
    en: "Border crossings",
    fr: "Passages frontaliers",
    de: "Grenzübergänge",
    zh: "过境",
    it: "Attraversamenti di confine",
    ru: "Пересечение границы",
  },
  taxi_f4: {
    es: "Precios honestos",
    en: "Honest pricing",
    fr: "Tarifs honnêtes",
    de: "Faire Preise",
    zh: "诚信定价",
    it: "Prezzi onesti",
    ru: "Честные цены",
  },
  taxi_cta: {
    es: "Reservar en NicaraguaTaxi.com",
    en: "Book now: NicaraguaTaxi.com",
    fr: "Réserver sur NicaraguaTaxi.com",
    de: "Buchen auf NicaraguaTaxi.com",
    zh: "立即预订: NicaraguaTaxi.com",
    it: "Prenota ora: NicaraguaTaxi.com",
    ru: "Забронировать: NicaraguaTaxi.com",
  },
  taxi_caption: {
    es: "Conductores locales · Recogidas puntuales",
    en: "Local drivers · On-time pickups",
    fr: "Chauffeurs locaux · Ponctualité",
    de: "Lokale Fahrer · Pünktlich",
    zh: "本地司机 · 准时接载",
    it: "Autisti locali · Prelievi puntuali",
    ru: "Местные водители · Подача вовремя",
  },

  /* Surf Plans + Friends */
  plans_eyebrow: {
    es: "Tu círculo",
    en: "Your circle",
    fr: "Ton cercle",
    de: "Dein Kreis",
    zh: "你的圈子",
    it: "La tua cerchia",
    ru: "Ваш круг",
  },
  plans_title: {
    es: "Planes de surf y amigos",
    en: "Surf Plans & Friends",
    fr: "Plans de surf & amis",
    de: "Surf-Pläne & Freunde",
    zh: "冲浪计划和朋友",
    it: "Piani Surf & Amici",
    ru: "Сёрф-планы и друзья",
  },
  plans_new: {
    es: "Nuevo plan",
    en: "New plan",
    fr: "Nouveau plan",
    de: "Neuer Plan",
    zh: "新计划",
    it: "Nuovo piano",
    ru: "Новый план",
  },
  plans_login: {
    es: "Inicia sesión para planificar una surfeada",
    en: "Sign in to plan a surf",
    fr: "Connecte-toi pour planifier une session",
    de: "Anmelden um Surf zu planen",
    zh: "登录以计划冲浪",
    it: "Accedi per pianificare un surf",
    ru: "Войдите, чтобы запланировать сёрф",
  },
  plans_tab_plans: {
    es: "Planes",
    en: "Plans",
    fr: "Plans",
    de: "Pläne",
    zh: "计划",
    it: "Piani",
    ru: "Планы",
  },
  plans_tab_friends: {
    es: "Amigos",
    en: "Friends",
    fr: "Amis",
    de: "Freunde",
    zh: "朋友",
    it: "Amici",
    ru: "Друзья",
  },
  plans_yours: {
    es: "Tus planes",
    en: "Your plans",
    fr: "Tes plans",
    de: "Deine Pläne",
    zh: "你的计划",
    it: "I tuoi piani",
    ru: "Ваши планы",
  },
  plans_others: {
    es: "De amigos y comunidad",
    en: "From friends & community",
    fr: "Amis & communauté",
    de: "Von Freunden & Community",
    zh: "来自朋友和社区",
    it: "Da amici e comunità",
    ru: "От друзей и сообщества",
  },
  plans_empty: {
    es: "No hay planes próximos — crea uno y comparte el enlace con amigos.",
    en: "No upcoming plans yet — create one and share the link with friends.",
    fr: "Aucun plan à venir — créez-en un et partagez le lien.",
    de: "Noch keine Pläne — erstelle einen und teile den Link.",
    zh: "尚无即将开始的计划 — 创建一个并与朋友分享链接。",
    it: "Nessun piano imminente — creane uno e condividi il link con gli amici.",
    ru: "Предстоящих планов пока нет — создайте план и поделитесь ссылкой с друзьями.",
  },
  friends_find: {
    es: "Buscar amigos por usuario",
    en: "Find friends by username",
    fr: "Rechercher des amis par nom d'utilisateur",
    de: "Freunde nach Nutzername suchen",
    zh: "按用户名查找朋友",
    it: "Trova amici per nome utente",
    ru: "Найти друзей по имени пользователя",
  },
  friends_incoming: {
    es: "Solicitudes recibidas",
    en: "Incoming requests",
    fr: "Demandes reçues",
    de: "Eingehende Anfragen",
    zh: "收到的请求",
    it: "Richieste in arrivo",
    ru: "Входящие запросы",
  },
  friends_outgoing: {
    es: "Solicitudes enviadas",
    en: "Pending invites you sent",
    fr: "Invitations envoyées",
    de: "Gesendete Anfragen",
    zh: "你已发送的待处理邀请",
    it: "Inviti inviati in sospeso",
    ru: "Отправленные вами приглашения",
  },
  friends_yours: {
    es: "Tus amigos",
    en: "Your friends",
    fr: "Tes amis",
    de: "Deine Freunde",
    zh: "你的朋友",
    it: "I tuoi amici",
    ru: "Ваши друзья",
  },
  friends_none: {
    es: "Aún no tienes amigos. Busca arriba y agrega algunos — luego verán tus planes solo-amigos.",
    en: "No friends yet. Search above and add a few — then they'll see your friends-only surf plans.",
    fr: "Pas encore d'amis. Cherchez ci-dessus pour en ajouter — ils verront vos plans amis-seulement.",
    de: "Noch keine Freunde. Suche oben und füge welche hinzu — dann sehen sie deine Freunde-Pläne.",
    zh: "还没有朋友。在上方搜索并添加一些朋友——然后他们就能看到你仅限朋友的冲浪计划。",
    it: "Nessun amico ancora. Cerca qui sopra e aggiungine alcuni — poi vedranno i tuoi piani di surf solo per amici.",
    ru: "Друзей пока нет. Найдите друзей в поиске выше и добавьте несколько — тогда они увидят ваши планы для сёрфинга, доступные только друзьям.",
  },
  vis_public: {
    es: "Público",
    en: "Public",
    fr: "Public",
    de: "Öffentlich",
    zh: "公开",
    it: "Pubblico",
    ru: "Для всех",
  },
  vis_friends: {
    es: "Solo amigos",
    en: "Friends only",
    fr: "Amis seulement",
    de: "Nur Freunde",
    zh: "仅限朋友",
    it: "Solo amici",
    ru: "Только для друзей",
  },
  vis_link: {
    es: "Solo enlace",
    en: "Link only",
    fr: "Lien uniquement",
    de: "Nur Link",
    zh: "仅限链接",
    it: "Solo con link",
    ru: "Только по ссылке",
  },
  join: {
    es: "Unirse",
    en: "Join",
    fr: "Rejoindre",
    de: "Beitreten",
    zh: "加入",
    it: "Partecipa",
    ru: "Присоединиться",
  },
  leave: {
    es: "Salir",
    en: "Leave",
    fr: "Quitter",
    de: "Verlassen",
    zh: "离开",
    it: "Lascia",
    ru: "Покинуть",
  },
  delete: {
    es: "Eliminar",
    en: "Delete",
    fr: "Supprimer",
    de: "Löschen",
    zh: "删除",
    it: "Elimina",
    ru: "Удалить",
  },

  /* Profile dialog */
  profile_title: {
    es: "Tu perfil",
    en: "Your profile",
    fr: "Ton profil",
    de: "Dein Profil",
    zh: "你的个人资料",
    it: "Il tuo profilo",
    ru: "Ваш профиль",
  },
  profile_photo: {
    es: "Foto de perfil",
    en: "Profile photo",
    fr: "Photo de profil",
    de: "Profilfoto",
    zh: "头像照片",
    it: "Foto del profilo",
    ru: "Фото профиля",
  },
  profile_photo_hint: {
    es: "JPG o PNG · hasta 5 MB. Toca el círculo para subir.",
    en: "JPG or PNG · up to 5 MB. Click the circle to upload.",
    fr: "JPG ou PNG · jusqu'à 5 Mo. Cliquez sur le cercle.",
    de: "JPG oder PNG · bis 5 MB. Auf den Kreis tippen.",
    zh: "JPG 或 PNG · 最大 5 MB。点击圆圈上传。",
    it: "JPG o PNG · fino a 5 MB. Clicca sul cerchio per caricare.",
    ru: "JPG или PNG · до 5 МБ. Нажмите на круг, чтобы загрузить.",
  },
  profile_name: {
    es: "Nombre",
    en: "Name",
    fr: "Nom",
    de: "Name",
    zh: "名称",
    it: "Nome",
    ru: "Имя",
  },
  profile_username: {
    es: "Usuario",
    en: "Username",
    fr: "Nom d'utilisateur",
    de: "Nutzername",
    zh: "用户名",
    it: "Nome utente",
    ru: "Имя пользователя",
  },
  profile_bio: {
    es: "Biografía corta",
    en: "Short bio",
    fr: "Bio courte",
    de: "Kurze Bio",
    zh: "个人简介",
    it: "Breve biografia",
    ru: "Краткая биография",
  },
  profile_bio_ph: {
    es: "Una línea o dos sobre ti — surfista / pescador / dueño de negocio / visitante…",
    en: "A line or two about you — surfer / fisher / business owner / visitor…",
    fr: "Une ou deux lignes sur vous — surfeur / pêcheur / propriétaire / visiteur…",
    de: "Ein paar Worte über dich — Surfer / Fischer / Geschäftsinhaber / Besucher…",
    zh: "关于你的一两句话 — 冲浪者 / 渔民 / 企业主 / 游客…",
    it: "Una riga o due su di te — surfista / pescatore / imprenditore / visitatore…",
    ru: "Пара строк о вас — сёрфер / рыбак / владелец бизнеса / гость…",
  },
  profile_social: {
    es: "Enlaces sociales",
    en: "Social links",
    fr: "Réseaux sociaux",
    de: "Social Links",
    zh: "社交链接",
    it: "Link social",
    ru: "Ссылки на соцсети",
  },
  profile_business: {
    es: "Negocio / Empresa",
    en: "Business / Company",
    fr: "Entreprise",
    de: "Geschäft / Firma",
    zh: "商业 / 公司",
    it: "Attività / Azienda",
    ru: "Бизнес / Компания",
  },
  profile_business_name: {
    es: "Nombre del negocio",
    en: "Business name",
    fr: "Nom de l'entreprise",
    de: "Geschäftsname",
    zh: "企业名称",
    it: "Nome dell'attività",
    ru: "Название компании",
  },
  profile_save: {
    es: "Guardar perfil",
    en: "Save profile",
    fr: "Enregistrer le profil",
    de: "Profil speichern",
    zh: "保存个人资料",
    it: "Salva profilo",
    ru: "Сохранить профиль",
  },

  /* Admin panel */
  admin_tools: {
    es: "Herramientas de administrador",
    en: "Admin tools",
    fr: "Outils d'administrateur",
    de: "Admin-Werkzeuge",
    zh: "管理工具",
    it: "Strumenti admin",
    ru: "Инструменты администратора",
  },
  admin_restricted: {
    es: "Restringido",
    en: "Restricted",
    fr: "Restreint",
    de: "Beschränkt",
    zh: "受限",
    it: "Riservato",
    ru: "Ограниченный доступ",
  },
  admin_roster: {
    es: "Lista de la comunidad — emails y datos de perfil",
    en: "Community roster — emails & profile data",
    fr: "Liste de la communauté — emails & données de profil",
    de: "Community-Liste — E-Mails & Profildaten",
    zh: "社区名册 — 电子邮件和个人资料数据",
    it: "Elenco della comunità — email e dati del profilo",
    ru: "Список сообщества — email и данные профилей",
  },
  admin_filter: {
    es: "Filtrar por email / nombre / usuario",
    en: "Filter by email / name / username",
    fr: "Filtrer par email / nom / utilisateur",
    de: "Nach E-Mail / Name / Nutzer filtern",
    zh: "按电子邮件 / 名称 / 用户名筛选",
    it: "Filtra per email / nome / nome utente",
    ru: "Фильтр по email / имени / имени пользователя",
  },
  admin_load_users: {
    es: "Cargar usuarios",
    en: "Load users",
    fr: "Charger les utilisateurs",
    de: "Nutzer laden",
    zh: "加载用户",
    it: "Carica utenti",
    ru: "Загрузить пользователей",
  },
  admin_export_csv: {
    es: "Exportar CSV",
    en: "Export CSV",
    fr: "Exporter CSV",
    de: "CSV exportieren",
    zh: "导出 CSV",
    it: "Esporta CSV",
    ru: "Экспорт CSV",
  },
  admin_purge_title: {
    es: "Borrar datos de prueba",
    en: "Wipe test data",
    fr: "Effacer les données de test",
    de: "Testdaten löschen",
    zh: "清除测试数据",
    it: "Cancella dati di test",
    ru: "Стереть тестовые данные",
  },
  admin_purge_hint: {
    es: "Úsalo solo para limpiar pruebas — elimina los registros permanentemente.",
    en: "Use these only to clean up testing — they permanently delete records.",
    fr: "À utiliser uniquement pour le nettoyage de tests — supprime définitivement.",
    de: "Nur zum Testaufräumen — löscht Datensätze dauerhaft.",
    zh: "仅用于清理测试 — 它们会永久删除记录。",
    it: "Usare solo per pulire i test — eliminano i record in modo permanente.",
    ru: "Используйте это только для очистки тестовых данных — записи удаляются навсегда.",
  },
  admin_purge_alerts: {
    es: "Todas las alertas/notas",
    en: "All alerts/notes",
    fr: "Toutes les alertes/notes",
    de: "Alle Warnungen/Notizen",
    zh: "所有警报/备注",
    it: "Tutte le allerte/note",
    ru: "Все оповещения/заметки",
  },
  admin_purge_chat: {
    es: "Todos los mensajes de chat",
    en: "All chat messages",
    fr: "Tous les messages",
    de: "Alle Chat-Nachrichten",
    zh: "所有聊天消息",
    it: "Tutti i messaggi chat",
    ru: "Все сообщения чата",
  },
  admin_purge_plans: {
    es: "Todos los planes de surf",
    en: "All surf plans",
    fr: "Tous les plans de surf",
    de: "Alle Surf-Pläne",
    zh: "所有冲浪计划",
    it: "Tutti i piani surf",
    ru: "Все сёрф-планы",
  },
  admin_purge_sessions: {
    es: "Todas las sesiones de surf",
    en: "All surf sessions",
    fr: "Toutes les sessions",
    de: "Alle Surf-Sessions",
    zh: "所有冲浪活动",
    it: "Tutte le sessioni di surf",
    ru: "Все сёрф-сессии",
  },

  /* Footer credit */
  footer_credit: {
    es: "Sitio web creado por",
    en: "Website created by",
    fr: "Site créé par",
    de: "Website erstellt von",
    zh: "网站创建者",
    it: "Sito web creato da",
    ru: "Сайт создан",
  },

  /* Push bell */
  push_alerts_on: {
    es: "Alertas activadas",
    en: "Alerts on",
    fr: "Alertes activées",
    de: "Alarme an",
    zh: "警报已开启",
    it: "Allerte attive",
    ru: "Оповещения вкл.",
  },
  push_alerts: {
    es: "Alertas",
    en: "Alerts",
    fr: "Alertes",
    de: "Alarme",
    zh: "警报",
    it: "Allerte",
    ru: "Оповещения",
  },

  /* Notification preferences */
  notif_title: {
    es: "Notificaciones",
    en: "Notifications",
    fr: "Notifications",
    de: "Benachrichtigungen",
    zh: "通知",
    it: "Notifiche",
    ru: "Уведомления",
  },
  notif_hint: {
    es: "Elige qué te avisamos. Puedes cambiarlo cuando quieras.",
    en: "Choose what you want to be notified about. You can change this anytime.",
    fr: "Choisis ce qui te sera notifié. Modifiable à tout moment.",
    de: "Wähle, worüber du benachrichtigt wirst. Jederzeit änderbar.",
    zh: "选择您想接收通知的内容。您可以随时更改此设置。",
    it: "Scegli di cosa vuoi essere avvisato. Puoi cambiarlo in qualsiasi momento.",
    ru: "Выберите, о чем вы хотите получать уведомления. Вы можете изменить это в любое время.",
  },
  notif_earthquakes: {
    es: "Terremotos cerca de SJDS",
    en: "Earthquakes near SJDS",
    fr: "Séismes près de SJDS",
    de: "Erdbeben in der Nähe von SJDS",
    zh: "SJDS 附近的地震",
    it: "Terremoti vicino a SJDS",
    ru: "Землетрясения рядом с SJDS",
  },
  notif_storms: {
    es: "Tormentas, huracanes y tsunamis",
    en: "Storms, hurricanes & tsunamis",
    fr: "Tempêtes, ouragans & tsunamis",
    de: "Stürme, Hurrikane & Tsunamis",
    zh: "风暴、飓风和海啸",
    it: "Tempeste, uragani e tsunami",
    ru: "Штормы, ураганы и цунами",
  },
  notif_admin: {
    es: "Avisos del administrador",
    en: "Admin announcements",
    fr: "Annonces de l'administrateur",
    de: "Admin-Ankündigungen",
    zh: "管理员公告",
    it: "Annunci dell'amministratore",
    ru: "Объявления администратора",
  },
  notif_chat: {
    es: "Mensajes de chat comunitario",
    en: "Community chat messages",
    fr: "Messages du chat communautaire",
    de: "Community-Chat-Nachrichten",
    zh: "社区聊天消息",
    it: "Messaggi della chat della comunità",
    ru: "Сообщения в чате сообщества",
  },
  notif_daily_surf: {
    es: "Reporte diario de surf (8:00 AM)",
    en: "Daily surf report (8:00 AM)",
    fr: "Rapport de surf quotidien (8h00)",
    de: "Tägliche Surf-Meldung (8:00 Uhr)",
    zh: "每日冲浪报告（早上8点）",
    it: "Report quotidiano del surf (ore 8:00)",
    ru: "Ежедневный отчёт о сёрфинге (8:00)",
  },
  footer_data: {
    es: "Datos",
    en: "Data",
    fr: "Données",
    de: "Daten",
    zh: "数据",
    it: "Dati",
    ru: "Данные",
  },
  footer_disclaimer: {
    es: "Aviso",
    en: "Disclaimer",
    fr: "Avertissement",
    de: "Hinweis",
    zh: "免责声明",
    it: "Disclaimer",
    ru: "Отказ от ответственности",
  },
  footer_location: {
    es: "San Juan del Sur, Nicaragua · Costa Pacífica",
    en: "San Juan del Sur, Nicaragua · Pacific Coast",
    fr: "San Juan del Sur, Nicaragua · Côte Pacifique",
    de: "San Juan del Sur, Nicaragua · Pazifikküste",
    zh: "机场接送",
    it: "San Juan del Sur, Nicaragua · Costa del Pacifico",
    ru: "Трансферы из аэропорта",
  },
  data_openmeteo: {
    es: "Open-Meteo (surf, clima)",
    en: "Open-Meteo (surf, weather)",
    fr: "Open-Meteo (surf, météo)",
    de: "Open-Meteo (Surf, Wetter)",
    zh: "Open-Meteo (冲浪、天气)",
    it: "Open-Meteo (surf, meteo)",
    ru: "Open-Meteo (сёрфинг, погода)",
  },
  data_usgs: {
    es: "USGS (sismos)",
    en: "USGS (earthquakes)",
    fr: "USGS (séismes)",
    de: "USGS (Erdbeben)",
    zh: "USGS (地震)",
    it: "USGS (terremoti)",
    ru: "USGS (землетрясения)",
  },
  data_noaa: {
    es: "NOAA NTWC (tsunami)",
    en: "NOAA NTWC (tsunami)",
    fr: "NOAA NTWC (tsunami)",
    de: "NOAA NTWC (Tsunami)",
    zh: "NOAA NTWC (海啸)",
    it: "NOAA NTWC (tsunami)",
    ru: "NOAA NTWC (цунами)",
  },
  data_ineter: {
    es: "INETER / SINAPRED (Nicaragua)",
    en: "INETER / SINAPRED (Nicaragua)",
    fr: "INETER / SINAPRED (Nicaragua)",
    de: "INETER / SINAPRED (Nicaragua)",
    zh: "INETER / SINAPRED (Nicaragua)",
    it: "INETER / SINAPRED (Nicaragua)",
    ru: "INETER / SINAPRED (Nicaragua)",
  },
  select_beach: {
    es: "Elige una playa",
    en: "Select a beach",
    fr: "Choisir une plage",
    de: "Strand wählen",
    zh: "选择一个海滩",
    it: "Seleziona una spiaggia",
    ru: "Выберите пляж",
  },
  no_quakes_msg: {
    es: "Sin sismos M5+ en 40 km en los últimos 30 días. 🤙",
    en: "No M5+ earthquakes within 25 miles in the last 30 days. 🤙",
    fr: "Aucun séisme M5+ dans un rayon de 40 km au cours des 30 derniers jours. 🤙",
    de: "Keine M5+ Erdbeben im Umkreis von 40 km in den letzten 30 Tagen. 🤙",
    zh: "Open-Meteo (冲浪, 天气)",
    it: "Open-Meteo (surf, meteo)",
    ru: "Open-Meteo (сёрфинг, погода)",
  },
  delete_alert_confirm: {
    es: "¿Eliminar esta alerta?",
    en: "Delete this alert?",
    fr: "Supprimer cette alerte ?",
    de: "Diese Warnung löschen?",
    zh: "删除此警报？",
    it: "Eliminare questa allerta?",
    ru: "Удалить это оповещение?",
  },
  admin_label: {
    es: "Admin",
    en: "Admin",
    fr: "Admin",
    de: "Admin",
    zh: "管理员",
    it: "Admin",
    ru: "Админ",
  },
  live_label: {
    es: "en vivo",
    en: "live",
    fr: "en direct",
    de: "live",
    zh: "直播",
    it: "in diretta",
    ru: "в эфире",
  },
  updating_label: {
    es: "actualizando",
    en: "updating",
    fr: "mise à jour",
    de: "wird aktualisiert",
    zh: "更新中",
    it: "aggiornamento",
    ru: "обновление",
  },
  chat_empty: {
    es: "🌊 Saluda para empezar la conversación.",
    en: "🌊 Say aloha to start the conversation.",
    fr: "🌊 Dites bonjour pour démarrer la conversation.",
    de: "🌊 Sag Hallo, um das Gespräch zu starten.",
    zh: "删除此警报？",
    it: "Eliminare questo avviso?",
    ru: "Удалить это оповещение?",
  },
  uploading: {
    es: "Subiendo…",
    en: "Uploading…",
    fr: "Téléchargement…",
    de: "Wird hochgeladen…",
    zh: "上传中…",
    it: "Caricamento…",
    ru: "Загрузка…",
  },
  ready_to_send: {
    es: "Listo para enviar",
    en: "Ready to send",
    fr: "Prêt à envoyer",
    de: "Bereit zum Senden",
    zh: "准备发送",
    it: "Pronto per l'invio",
    ru: "Готово к отправке",
  },
  upload_failed: {
    es: "Error al subir la imagen",
    en: "Image upload failed",
    fr: "Échec de l'envoi",
    de: "Bild-Upload fehlgeschlagen",
    zh: "图片上传失败",
    it: "Caricamento immagine non riuscito",
    ru: "Не удалось загрузить изображение",
  },
  surf_unavailable: {
    es: "Pronóstico de surf no disponible. Intenta en unos minutos.",
    en: "Surf forecast temporarily unavailable. Try again in a few minutes.",
    fr: "Prévisions surf indisponibles. Réessayez dans quelques minutes.",
    de: "Surf-Vorhersage vorübergehend nicht verfügbar. Bitte in einigen Minuten erneut versuchen.",
    zh: "上传中…",
    it: "Caricamento in corso…",
    ru: "Загрузка…",
  },
  weather_unavailable: {
    es: "Datos de clima no disponibles. Surf, mareas y luna siguen en vivo.",
    en: "Weather data temporarily unavailable. Surf, tide and moon data still live.",
    fr: "Données météo indisponibles. Surf, marée et lune restent en direct.",
    de: "Wetterdaten nicht verfügbar. Surf-, Gezeiten- und Monddaten weiter live.",
    zh: "天气数据暂时不可用。冲浪、潮汐和月相数据仍然有效。",
    it: "Dati meteo temporaneamente non disponibili. I dati su surf, maree e luna sono ancora attivi.",
    ru: "Данные о погоде временно недоступны. Данные о сёрфинге, приливах и луне по-прежнему доступны.",
  },
  peak: {
    es: "Pico",
    en: "Peak",
    fr: "Pic",
    de: "Spitze",
    zh: "峰值",
    it: "Picco",
    ru: "Пик",
  },
  wind_label: {
    es: "viento",
    en: "wind",
    fr: "vent",
    de: "Wind",
    zh: "风",
    it: "vento",
    ru: "ветер",
  },
  beach_note_placeholder: {
    es: "ej. Resaca fuerte en marea alta — surfea la esquina norte.",
    en: "e.g. Strong south rip at high tide — surf the north corner.",
    fr: "ex. Courant fort à marée haute — surfez le coin nord.",
    de: "z.B. Starke Strömung bei Hochwasser — surfe die Nord-Ecke.",
    zh: "峰值",
    it: "Picco",
    ru: "Пик",
  },
  cancel: {
    es: "Cancelar",
    en: "Cancel",
    fr: "Annuler",
    de: "Abbrechen",
    zh: "取消",
    it: "Annulla",
    ru: "Отмена",
  },
  auth_welcome_back: {
    es: "Bienvenido de vuelta a la comunidad SJDS.",
    en: "Welcome back to the SJDS community.",
    fr: "Bienvenue dans la communauté SJDS.",
    de: "Willkommen zurück in der SJDS-Community.",
    zh: "取消",
    it: "Annulla",
    ru: "Отмена",
  },
  auth_create_account: {
    es: "Crea una cuenta gratis para unirte al chat en vivo.",
    en: "Create a free account to join the live community chat.",
    fr: "Créez un compte gratuit pour rejoindre le chat en direct.",
    de: "Erstelle ein kostenloses Konto, um am Live-Chat teilzunehmen.",
    zh: "创建一个免费帐户以加入实时社区聊天。",
    it: "Crea un account gratuito per unirti alla chat della community dal vivo.",
    ru: "Создайте бесплатную учётную запись, чтобы присоединиться к живому чату сообщества.",
  },
  wcond_0: {
    es: "Despejado",
    en: "Clear",
    fr: "Dégagé",
    de: "Klar",
    zh: "晴",
    it: "Sereno",
    ru: "Ясно",
  },
  wcond_1: {
    es: "Mayormente despejado",
    en: "Mostly clear",
    fr: "Plutôt clair",
    de: "Überwiegend klar",
    zh: "大部晴朗",
    it: "Prevalentemente sereno",
    ru: "В основном ясно",
  },
  wcond_2: {
    es: "Parcialmente nublado",
    en: "Partly cloudy",
    fr: "Partiellement nuageux",
    de: "Teilweise bewölkt",
    zh: "多云",
    it: "Parzialmente nuvoloso",
    ru: "Переменная облачность",
  },
  wcond_3: {
    es: "Nublado",
    en: "Overcast",
    fr: "Couvert",
    de: "Bedeckt",
    zh: "阴",
    it: "Coperto",
    ru: "Пасмурно",
  },
  wcond_45: {
    es: "Niebla",
    en: "Fog",
    fr: "Brouillard",
    de: "Nebel",
    zh: "雾",
    it: "Nebbia",
    ru: "Туман",
  },
  wcond_51: {
    es: "Llovizna ligera",
    en: "Light drizzle",
    fr: "Bruine légère",
    de: "Leichter Nieselregen",
    zh: "小毛毛雨",
    it: "Pioviggine leggera",
    ru: "Лёгкая морось",
  },
  wcond_53: {
    es: "Llovizna",
    en: "Drizzle",
    fr: "Bruine",
    de: "Nieselregen",
    zh: "毛毛雨",
    it: "Pioviggine",
    ru: "Морось",
  },
  wcond_55: {
    es: "Llovizna fuerte",
    en: "Heavy drizzle",
    fr: "Bruine forte",
    de: "Starker Nieselregen",
    zh: "大毛毛雨",
    it: "Pioviggine forte",
    ru: "Сильная морось",
  },
  wcond_61: {
    es: "Lluvia ligera",
    en: "Light rain",
    fr: "Pluie légère",
    de: "Leichter Regen",
    zh: "小雨",
    it: "Pioggia debole",
    ru: "Небольшой дождь",
  },
  wcond_63: {
    es: "Lluvia",
    en: "Rain",
    fr: "Pluie",
    de: "Regen",
    zh: "雨",
    it: "Pioggia",
    ru: "Дождь",
  },
  wcond_65: {
    es: "Lluvia fuerte",
    en: "Heavy rain",
    fr: "Pluie forte",
    de: "Starker Regen",
    zh: "大雨",
    it: "Pioggia forte",
    ru: "Сильный дождь",
  },
  wcond_71: {
    es: "Nieve",
    en: "Snow",
    fr: "Neige",
    de: "Schnee",
    zh: "雪",
    it: "Neve",
    ru: "Снег",
  },
  wcond_80: {
    es: "Chubascos",
    en: "Showers",
    fr: "Averses",
    de: "Schauer",
    zh: "阵雨",
    it: "Rovescio",
    ru: "Ливень",
  },
  wcond_82: {
    es: "Chubascos fuertes",
    en: "Heavy showers",
    fr: "Fortes averses",
    de: "Starke Schauer",
    zh: "大阵雨",
    it: "Forti rovesci",
    ru: "Сильный ливень",
  },
  wcond_95: {
    es: "Tormenta eléctrica",
    en: "Thunderstorm",
    fr: "Orage",
    de: "Gewitter",
    zh: "雷暴",
    it: "Temporale",
    ru: "Гроза",
  },
  best_window: {
    es: "Mejor ventana de surf",
    en: "Best surf window",
    fr: "Meilleure fenêtre",
    de: "Beste Surf-Zeit",
    zh: "最佳冲浪时段",
    it: "Miglior finestra per il surf",
    ru: "Лучшее время для сёрфинга",
  },
  beach_notes: {
    es: "Notas del admin",
    en: "Beach notes from admin",
    fr: "Notes de l'admin",
    de: "Admin-Notizen",
    zh: "来自管理员的海滩备注",
    it: "Note sulla spiaggia dall'admin",
    ru: "Заметки о пляже от администратора",
  },
  save: {
    es: "Guardar",
    en: "Save",
    fr: "Enregistrer",
    de: "Speichern",
    zh: "保存",
    it: "Salva",
    ru: "Сохранить",
  },
  edit: {
    es: "Editar",
    en: "Edit",
    fr: "Éditer",
    de: "Bearbeiten",
    zh: "编辑",
    it: "Modifica",
    ru: "Править",
  },
  no_notes_yet: {
    es: "Aún no hay notas.",
    en: "No notes yet.",
    fr: "Pas encore de notes.",
    de: "Noch keine Notizen.",
    zh: "暂无备注。",
    it: "Nessuna nota ancora.",
    ru: "Заметок пока нет.",
  },
  estimated_tides: {
    es: "Mareas estimadas (no oficial)",
    en: "Estimated tides (not official)",
    fr: "Marées estimées (non officielles)",
    de: "Geschätzte Gezeiten (nicht offiziell)",
    zh: "预估潮汐 (非官方)",
    it: "Maree stimate (non ufficiali)",
    ru: "Примерные приливы (неофициально)",
  },
  saved_to_phone: {
    es: "¿Guardarla en tu teléfono?",
    en: "Save it to your phone?",
    fr: "Enregistrer sur votre téléphone ?",
    de: "Auf dem Telefon speichern?",
    zh: "保存到您的手机？",
    it: "Salvarla sul tuo telefono?",
    ru: "Сохранить на телефон?",
  },
  install_hint: {
    es: "En iPhone: Compartir → Añadir a la pantalla de inicio.",
    en: "On iPhone: Share → Add to Home Screen.",
    fr: "Sur iPhone : Partager → Sur l'écran d'accueil.",
    de: "Auf dem iPhone: Teilen → Zum Home-Bildschirm.",
    zh: "晴朗",
    it: "Su iPhone: Condividi → Aggiungi a schermata Home.",
    ru: "Ясно",
  },

  /* --- Suggestions section ----------------------------------------- */
  sug_eyebrow: { es: "Comunidad · Sugerencias", en: "Community · Suggestions", fr: "Communauté · Suggestions", de: "Community · Vorschläge", zh: "社区 · 建议", it: "Comunità · Suggerimenti", ru: "Сообщество · Предложения" },
  sug_title: { es: "¿Qué quieres ver en SJDS.app?", en: "What do you want to see on SJDS.app?", fr: "Que voulez-vous voir sur SJDS.app ?", de: "Was möchtest du auf SJDS.app sehen?", zh: "您希望在 SJDS.app 上看到什么？", it: "Cosa vorresti vedere su SJDS.app?", ru: "Что вы хотите видеть на SJDS.app?" },
  sug_subtitle: {
    es: "Ofertas de empleo, compra y venta, eventos mensuales, recaudaciones y más — comparte tu idea y el equipo de SJDS la revisará.",
    en: "Now-hiring boards, buy & sell, monthly events, fundraisers, and more — share your idea and the SJDS team will review it.",
    fr: "Offres d'emploi, achat et vente, événements mensuels, collectes de fonds, et plus — partagez votre idée, l'équipe SJDS l'examinera.",
    de: "Stellenangebote, Kaufen und Verkaufen, monatliche Events, Spendenaktionen und mehr — teile deine Idee und das SJDS-Team prüft sie.",
    zh: "招聘信息、二手买卖、每月活动、募款等等——分享你的想法，SJDS 团队会进行审核。",
    it: "Annunci di lavoro, compra-vendita, eventi mensili, raccolte fondi e altro — condividi la tua idea e il team SJDS la esaminerà.",
    ru: "Объявления о работе, купля-продажа, ежемесячные мероприятия, сборы средств и многое другое — поделитесь идеей, команда SJDS её рассмотрит.",
  },
  sug_cat_hiring: { es: "Empleo", en: "Now hiring", fr: "Emplois", de: "Stellenangebote", zh: "招聘", it: "Lavoro", ru: "Вакансии" },
  sug_cat_buy_sell: { es: "Compra/Venta", en: "Buy & sell", fr: "Achat & vente", de: "Kaufen & verkaufen", zh: "买卖", it: "Compra & vendi", ru: "Купля/продажа" },
  sug_cat_events: { es: "Eventos", en: "Events", fr: "Événements", de: "Veranstaltungen", zh: "活动", it: "Eventi", ru: "Мероприятия" },
  sug_cat_fundraisers: { es: "Recaudaciones", en: "Fundraisers", fr: "Collectes", de: "Spendenaktionen", zh: "募款", it: "Raccolte fondi", ru: "Сбор средств" },
  sug_cat_other: { es: "Otro", en: "Other", fr: "Autre", de: "Sonstiges", zh: "其他", it: "Altro", ru: "Другое" },
  sug_title_placeholder: { es: "Título corto de tu idea", en: "Short title for your idea", fr: "Titre court de votre idée", de: "Kurzer Titel deiner Idee", zh: "想法的简短标题", it: "Titolo breve della tua idea", ru: "Краткое название вашей идеи" },
  sug_body_placeholder: {
    es: "Cuéntanos más — ¿qué resolvería? ¿quién la usaría?",
    en: "Tell us more — what would it solve? who would use it?",
    fr: "Dites-nous en plus — que résoudrait-elle ? qui l'utiliserait ?",
    de: "Erzähl uns mehr — was würde es lösen? wer würde es nutzen?",
    zh: "详细说明——它能解决什么问题？谁会使用它？",
    it: "Raccontaci di più — cosa risolverebbe? chi la userebbe?",
    ru: "Расскажите подробнее — что это решит? кто будет пользоваться?",
  },
  sug_submit: { es: "Enviar idea", en: "Send idea", fr: "Envoyer", de: "Idee senden", zh: "提交想法", it: "Invia idea", ru: "Отправить идею" },
  sug_signed_as: { es: "Como", en: "As", fr: "En tant que", de: "Als", zh: "身份：", it: "Come", ru: "От имени" },
  sug_thanks: { es: "¡Gracias! El admin recibirá tu sugerencia.", en: "Thanks! The admin will receive your suggestion.", fr: "Merci ! L'admin recevra votre suggestion.", de: "Danke! Der Admin erhält deinen Vorschlag.", zh: "感谢您的建议！管理员会查看。", it: "Grazie! L'admin riceverà il tuo suggerimento.", ru: "Спасибо! Администратор получит ваше предложение." },
  sug_validation: { es: "Título ≥ 3 caracteres y descripción ≥ 10.", en: "Title needs 3+ chars and description 10+.", fr: "Titre ≥ 3 caractères et description ≥ 10.", de: "Titel ≥ 3 Zeichen und Beschreibung ≥ 10.", zh: "标题至少3个字符，描述至少10个。", it: "Titolo ≥ 3 caratteri e descrizione ≥ 10.", ru: "Заголовок ≥ 3 символов и описание ≥ 10." },
  sug_login_prompt: {
    es: "Crea una cuenta gratuita o inicia sesión para enviar tus ideas al equipo.",
    en: "Create a free account or sign in to send your ideas to the team.",
    fr: "Créez un compte gratuit ou connectez-vous pour envoyer vos idées à l'équipe.",
    de: "Erstelle ein kostenloses Konto oder melde dich an, um Ideen ans Team zu senden.",
    zh: "创建免费账户或登录，把您的想法发送给团队。",
    it: "Crea un account gratuito o accedi per inviare le tue idee al team.",
    ru: "Создайте бесплатный аккаунт или войдите, чтобы отправить идеи команде.",
  },
  sug_mine_title: { es: "Mis sugerencias", en: "My suggestions", fr: "Mes suggestions", de: "Meine Vorschläge", zh: "我的建议", it: "I miei suggerimenti", ru: "Мои предложения" },
  sug_admin_reply: { es: "Respuesta admin", en: "Admin reply", fr: "Réponse admin", de: "Admin-Antwort", zh: "管理员回复", it: "Risposta admin", ru: "Ответ админа" },
  sug_status_new: { es: "Nuevo", en: "New", fr: "Nouveau", de: "Neu", zh: "新", it: "Nuovo", ru: "Новое" },
  sug_status_planned: { es: "Planificado", en: "Planned", fr: "Planifié", de: "Geplant", zh: "已计划", it: "Pianificato", ru: "Запланировано" },
  sug_status_in_progress: { es: "En progreso", en: "In progress", fr: "En cours", de: "In Bearbeitung", zh: "进行中", it: "In corso", ru: "В работе" },
  sug_status_done: { es: "Hecho", en: "Done", fr: "Terminé", de: "Erledigt", zh: "已完成", it: "Fatto", ru: "Готово" },
  sug_status_rejected: { es: "Rechazado", en: "Rejected", fr: "Rejeté", de: "Abgelehnt", zh: "已拒绝", it: "Rifiutato", ru: "Отклонено" },

  /* --- Local Partners section ------------------------------------- */
  partners_eyebrow: { es: "Aliados locales · SJDS", en: "Local partners · SJDS", fr: "Partenaires locaux · SJDS", de: "Lokale Partner · SJDS", zh: "本地合作伙伴 · SJDS", it: "Partner locali · SJDS", ru: "Локальные партнёры · SJDS" },
  partners_title: { es: "¡Aliados locales de San Juan del Sur!", en: "Local San Juan del Sur Partners!", fr: "Partenaires locaux de San Juan del Sur !", de: "Lokale Partner aus San Juan del Sur!", zh: "圣胡安德尔苏尔本地合作伙伴！", it: "Partner locali di San Juan del Sur!", ru: "Местные партнёры в Сан-Хуан-дель-Сур!" },
  partners_subtitle: {
    es: "Negocios y creadores de SJDS que apoyamos con orgullo. Haz clic en cualquiera para visitar su sitio.",
    en: "Businesses and creators in SJDS we proudly support. Tap any card to visit their site.",
    fr: "Entreprises et créateurs de SJDS que nous soutenons avec fierté. Cliquez sur n'importe quelle carte pour visiter leur site.",
    de: "Unternehmen und Kreative aus SJDS, die wir mit Stolz unterstützen. Klicke auf eine Karte, um die Seite zu besuchen.",
    zh: "我们引以为豪支持的 SJDS 当地企业与创作者。点击任意卡片即可访问他们的网站。",
    it: "Attività e creatori di SJDS che sosteniamo con orgoglio. Tocca una carta per visitare il sito.",
    ru: "Бизнесы и создатели в SJDS, которых мы с гордостью поддерживаем. Нажмите на любую карточку, чтобы перейти на сайт.",
  },
  partners_cta_eyebrow: { es: "Diseño web · Nicaragua", en: "Web design · Nicaragua", fr: "Conception web · Nicaragua", de: "Webdesign · Nicaragua", zh: "网站设计 · 尼加拉瓜", it: "Web design · Nicaragua", ru: "Веб-дизайн · Никарагуа" },
  partners_cta_title: {
    es: "¿Buscas un sitio web increíble en Nicaragua?",
    en: "Looking for an incredible website in Nicaragua?",
    fr: "Vous cherchez un site web incroyable au Nicaragua ?",
    de: "Du suchst eine großartige Website in Nicaragua?",
    zh: "想要在尼加拉瓜拥有一个出色的网站吗？",
    it: "Cerchi un sito web straordinario in Nicaragua?",
    ru: "Ищете потрясающий сайт в Никарагуа?",
  },
  partners_cta_subtitle: {
    es: "Contacta a Greg Miceli — diseñador de cada uno de los sitios listados arriba.",
    en: "Reach out to Greg Miceli — designer of every site listed above.",
    fr: "Contactez Greg Miceli — concepteur de chaque site répertorié ci-dessus.",
    de: "Wende dich an Greg Miceli — Designer aller oben aufgeführten Seiten.",
    zh: "联系 Greg Miceli——以上所有网站的设计师。",
    it: "Contatta Greg Miceli — designer di tutti i siti elencati sopra.",
    ru: "Напишите Greg Miceli — дизайнеру всех перечисленных выше сайтов.",
  },
  partners_cta_button: { es: "Chatear por WhatsApp", en: "Chat on WhatsApp", fr: "Discuter sur WhatsApp", de: "Auf WhatsApp chatten", zh: "WhatsApp 联系", it: "Chatta su WhatsApp", ru: "Написать в WhatsApp" },

  // LocalsSlider — top-of-page partner rotator on /sjds-locals
  locals_slider_taxi_eyebrow: {
    es: "Socio de transporte local",
    en: "Local transport partner",
    fr: "Partenaire de transport local",
    de: "Lokaler Transport-Partner",
    zh: "本地交通合作伙伴",
    it: "Partner di trasporto locale",
    ru: "Партнёр по местному транспорту",
  },
  locals_slider_taxi_title: {
    es: "¿Necesitas un taxi o shuttle en San Juan del Sur?",
    en: "Need a taxi or shuttle in San Juan del Sur?",
    fr: "Besoin d'un taxi ou navette à San Juan del Sur ?",
    de: "Brauchst du ein Taxi oder Shuttle in San Juan del Sur?",
    zh: "在 San Juan del Sur 需要出租车或班车?",
    it: "Hai bisogno di un taxi o navetta a San Juan del Sur?",
    ru: "Нужно такси или шаттл в San Juan del Sur?",
  },
  locals_slider_taxi_body: {
    es: "Conductores confiables, precios fijos justos, traslados al aeropuerto y viajes a las playas. Reserva al instante con Nicaragua Taxi.",
    en: "Trusted drivers, fair fixed prices, airport pickups, and beach runs. Book instantly with Nicaragua Taxi.",
    fr: "Chauffeurs de confiance, prix fixes justes, transferts aéroport et sorties à la plage. Réservez instantanément avec Nicaragua Taxi.",
    de: "Vertrauenswürdige Fahrer, faire Festpreise, Flughafentransfers und Strandfahrten. Buche sofort bei Nicaragua Taxi.",
    zh: "可靠的司机、公平的固定价格、机场接送和海滩之旅。立即通过 Nicaragua Taxi 预订。",
    it: "Autisti affidabili, prezzi fissi equi, transfer aeroportuali e giri in spiaggia. Prenota subito con Nicaragua Taxi.",
    ru: "Надёжные водители, честные фиксированные цены, трансферы из аэропорта и поездки на пляж. Бронируй мгновенно у Nicaragua Taxi.",
  },
  locals_slider_taxi_cta: {
    es: "Reservar un viaje",
    en: "Book a ride",
    fr: "Réserver un trajet",
    de: "Fahrt buchen",
    zh: "预订行程",
    it: "Prenota una corsa",
    ru: "Заказать поездку",
  },
  locals_slider_spartan_eyebrow: {
    es: "Únete a la comunidad fit de SJDS",
    en: "Join the SJDS fit community",
    fr: "Rejoignez la communauté fit de SJDS",
    de: "Werde Teil der SJDS-Fitness-Community",
    zh: "加入 SJDS 健身社群",
    it: "Unisciti alla community fitness di SJDS",
    ru: "Присоединяйся к фитнес-сообществу SJDS",
  },
  locals_slider_spartan_title: {
    es: "Entrena fuerte en Spartan Fitness Club SJDS",
    en: "Train strong at Spartan Fitness Club SJDS",
    fr: "Entraîne-toi fort au Spartan Fitness Club SJDS",
    de: "Trainiere stark im Spartan Fitness Club SJDS",
    zh: "在 Spartan Fitness Club SJDS 强力训练",
    it: "Allenati forte allo Spartan Fitness Club SJDS",
    ru: "Тренируйся сильно в Spartan Fitness Club SJDS",
  },
  locals_slider_spartan_body: {
    es: "Inscríbete hoy — gimnasio moderno en el corazón de San Juan del Sur. Clases, entrenamiento personal, pases diarios y membresías.",
    en: "Sign up today — modern gym in the heart of San Juan del Sur. Classes, personal training, day passes & memberships.",
    fr: "Inscrivez-vous aujourd'hui — salle de sport moderne au cœur de San Juan del Sur. Cours, coaching personnel, pass journée et abonnements.",
    de: "Melde dich heute an — modernes Fitnessstudio im Herzen von San Juan del Sur. Kurse, Personal Training, Tageskarten & Mitgliedschaften.",
    zh: "今天就报名——位于 San Juan del Sur 中心的现代健身房。课程、私教、日卡与会员。",
    it: "Iscriviti oggi — palestra moderna nel cuore di San Juan del Sur. Classi, personal training, pass giornalieri e abbonamenti.",
    ru: "Запишись сегодня — современный зал в центре San Juan del Sur. Групповые классы, персональные тренировки, дневные абонементы и членство.",
  },
  locals_slider_spartan_cta: {
    es: "Inscríbete hoy",
    en: "Sign up today",
    fr: "Inscrivez-vous",
    de: "Jetzt anmelden",
    zh: "立即报名",
    it: "Iscriviti oggi",
    ru: "Записаться",
  },
  locals_slider_eltimon_eyebrow: {
    es: "NicaBros × El Timón · Nivel Especial",
    en: "NicaBros × El Timón · Special Level",
    fr: "NicaBros × El Timón · Niveau Spécial",
    de: "NicaBros × El Timón · Spezial-Level",
    zh: "NicaBros × El Timón · 特别关卡",
    it: "NicaBros × El Timón · Livello Speciale",
    ru: "NicaBros × El Timón · Специальный уровень",
  },
  locals_slider_eltimon_title: {
    es: "Gana una tarjeta de regalo de $25 de El Timón + 10% de descuento en tu próxima cuenta",
    en: "Win a $25 El Timón gift card + 10% off your next bill",
    fr: "Gagne une carte-cadeau El Timón de 25 $ + 10 % sur ta prochaine addition",
    de: "Gewinne eine 25-$-El-Timón-Geschenkkarte + 10 % Rabatt auf deine nächste Rechnung",
    zh: "赢取 $25 El Timón 礼品卡 + 下次消费 10% 折扣",
    it: "Vinci una gift card El Timón da 25 $ + 10% di sconto sul prossimo conto",
    ru: "Выиграй подарочную карту El Timón на $25 + 10% скидку на следующий счёт",
  },
  locals_slider_eltimon_body: {
    es: "Juega el nivel especial de NicaBros El Timón para desbloquear 10% de descuento en tu próxima cuenta. El mejor puntaje del mes gana una tarjeta de regalo de $25.",
    en: "Play the special NicaBros El Timón level to unlock 10% off your next bill. Top monthly score wins a $25 gift card.",
    fr: "Joue le niveau spécial NicaBros El Timón pour obtenir 10 % sur ta prochaine addition. Le meilleur score mensuel gagne une carte-cadeau de 25 $.",
    de: "Spiele das spezielle NicaBros-El-Timón-Level und sichere dir 10 % Rabatt auf deine nächste Rechnung. Der beste Monats-Score gewinnt eine 25-$-Geschenkkarte.",
    zh: "玩特别的 NicaBros El Timón 关卡解锁下次消费 10% 折扣。本月最高分赢得 $25 礼品卡。",
    it: "Gioca il livello speciale NicaBros El Timón per sbloccare il 10% di sconto sul prossimo conto. Il punteggio migliore del mese vince una gift card da 25 $.",
    ru: "Пройди специальный уровень NicaBros El Timón, чтобы получить 10% скидку на следующий счёт. Лучший результат месяца — карта на $25.",
  },
  locals_slider_eltimon_cta: {
    es: "Jugar y ganar",
    en: "Play & win",
    fr: "Jouer et gagner",
    de: "Spielen & gewinnen",
    zh: "开始游戏",
    it: "Gioca e vinci",
    ru: "Играть и выиграть",
  },

  // NicaraguaTaxiCTA — Spartan slide (home-page rotator)
  partner_spartan_eyebrow: {
    es: "Gimnasio partner",
    en: "Partner gym",
    fr: "Salle partenaire",
    de: "Partner-Fitnessstudio",
    zh: "合作健身房",
    it: "Palestra partner",
    ru: "Партнёр-зал",
  },
  partner_spartan_headline: {
    es: "Entrena fuerte en Spartan Fitness Club SJDS",
    en: "Train strong at Spartan Fitness Club SJDS",
    fr: "Entraîne-toi fort au Spartan Fitness Club SJDS",
    de: "Trainiere stark im Spartan Fitness Club SJDS",
    zh: "在 Spartan Fitness Club SJDS 强力训练",
    it: "Allenati forte allo Spartan Fitness Club SJDS",
    ru: "Тренируйся сильно в Spartan Fitness Club SJDS",
  },
  partner_spartan_body: {
    es: "El hogar del fitness en San Juan del Sur. Equipos modernos, clases grupales, entrenamiento personal, pases diarios y membresías completas — a pasos de la bahía.",
    en: "The home of fitness in San Juan del Sur. Modern equipment, group classes, personal training, day passes and full memberships — all steps from the bay.",
    fr: "La maison du fitness à San Juan del Sur. Matériel moderne, cours collectifs, coaching personnel, pass journée et abonnements — à deux pas de la baie.",
    de: "Das Zuhause des Fitness in San Juan del Sur. Moderne Geräte, Gruppenkurse, Personal Training, Tageskarten und Vollmitgliedschaften — nur Schritte von der Bucht entfernt.",
    zh: "San Juan del Sur 的健身之家。现代化设备、团课、私教、日卡与完整会员——距海湾仅几步之遥。",
    it: "La casa del fitness a San Juan del Sur. Attrezzature moderne, lezioni di gruppo, personal training, pass giornalieri e abbonamenti completi — a pochi passi dalla baia.",
    ru: "Дом фитнеса в San Juan del Sur. Современное оборудование, групповые классы, персональные тренировки, дневные абонементы и полное членство — в двух шагах от бухты.",
  },
  partner_spartan_f1: {
    es: "Pesas libres y máquinas",
    en: "Free weights & machines",
    fr: "Poids libres & machines",
    de: "Freihanteln & Geräte",
    zh: "自由重量与器械",
    it: "Pesi liberi e macchine",
    ru: "Свободные веса и тренажёры",
  },
  partner_spartan_f2: {
    es: "Clases grupales",
    en: "Group classes",
    fr: "Cours collectifs",
    de: "Gruppenkurse",
    zh: "团体课程",
    it: "Lezioni di gruppo",
    ru: "Групповые занятия",
  },
  partner_spartan_f3: {
    es: "Entrenamiento personal",
    en: "Personal training",
    fr: "Coaching personnel",
    de: "Personal Training",
    zh: "私人训练",
    it: "Personal training",
    ru: "Персональные тренировки",
  },
  partner_spartan_f4: {
    es: "Pases diarios y membresías",
    en: "Day passes & memberships",
    fr: "Pass journée & abonnements",
    de: "Tageskarten & Mitgliedschaften",
    zh: "日卡与会员",
    it: "Pass giornalieri e abbonamenti",
    ru: "Дневные абонементы и членство",
  },
  partner_spartan_cta: {
    es: "Inscríbete hoy",
    en: "Sign up today",
    fr: "Inscrivez-vous",
    de: "Jetzt anmelden",
    zh: "立即报名",
    it: "Iscriviti oggi",
    ru: "Записаться",
  },

  // Digital Nomad Nicaragua — shared across sliders
  partner_dnn_eyebrow: {
    es: "Vida de nómada digital en Nicaragua",
    en: "Digital nomad life in Nicaragua",
    fr: "La vie de nomade numérique au Nicaragua",
    de: "Digital-Nomaden-Leben in Nicaragua",
    zh: "尼加拉瓜的数字游民生活",
    it: "Vita da nomade digitale in Nicaragua",
    ru: "Жизнь цифрового кочевника в Nicaragua",
  },
  partner_dnn_title: {
    es: "Trabaja, explora y pertenece — Digital Nomad Nicaragua",
    en: "Work, explore, belong — Digital Nomad Nicaragua",
    fr: "Travaille, explore, appartiens — Digital Nomad Nicaragua",
    de: "Arbeiten, entdecken, dazugehören — Digital Nomad Nicaragua",
    zh: "工作、探索、归属 — Digital Nomad Nicaragua",
    it: "Lavora, esplora, appartieni — Digital Nomad Nicaragua",
    ru: "Работай, исследуй, принадлежи — Digital Nomad Nicaragua",
  },
  partner_dnn_body: {
    es: "Guías, visas, coworking, comunidad y recursos para quienes quieren vivir y trabajar remoto desde Nicaragua. Creado por Greg Miceli.",
    en: "Guides, visas, coworking, community and resources for anyone who wants to live and work remotely from Nicaragua. Built by Greg Miceli.",
    fr: "Guides, visas, coworking, communauté et ressources pour vivre et travailler à distance depuis le Nicaragua. Créé par Greg Miceli.",
    de: "Guides, Visa, Coworking, Community und Ressourcen für alle, die remote aus Nicaragua leben und arbeiten wollen. Entwickelt von Greg Miceli.",
    zh: "指南、签证、联合办公、社群与资源 — 为想在 Nicaragua 远程生活与工作的人而建。作者:Greg Miceli。",
    it: "Guide, visti, coworking, community e risorse per chi vuole vivere e lavorare da remoto dal Nicaragua. Realizzato da Greg Miceli.",
    ru: "Гиды, визы, коворкинги, сообщество и ресурсы для тех, кто хочет жить и работать удалённо из Nicaragua. Создано Greg Miceli.",
  },
  partner_dnn_cta: {
    es: "Explorar la guía",
    en: "Explore the guide",
    fr: "Découvrir le guide",
    de: "Guide entdecken",
    zh: "查看指南",
    it: "Esplora la guida",
    ru: "Открыть гайд",
  },
  partner_dnn_f1: {
    es: "Visa & residencia",
    en: "Visa & residency",
    fr: "Visa & résidence",
    de: "Visa & Aufenthalt",
    zh: "签证与居留",
    it: "Visto & residenza",
    ru: "Виза и ВНЖ",
  },
  partner_dnn_f2: {
    es: "Coworking & wifi",
    en: "Coworking & wifi",
    fr: "Coworking & wifi",
    de: "Coworking & WLAN",
    zh: "联合办公与 Wi-Fi",
    it: "Coworking & wifi",
    ru: "Коворкинг и Wi-Fi",
  },
  partner_dnn_f3: {
    es: "Comunidad local",
    en: "Local community",
    fr: "Communauté locale",
    de: "Lokale Community",
    zh: "本地社群",
    it: "Community locale",
    ru: "Местное сообщество",
  },
  partner_dnn_f4: {
    es: "Alojamiento mensual",
    en: "Monthly stays",
    fr: "Séjours mensuels",
    de: "Monatsaufenthalte",
    zh: "按月住宿",
    it: "Soggiorni mensili",
    ru: "Проживание помесячно",
  },

  // Sister-site strips on Home page
  sister_visit: {
    es: "Visitar",
    en: "Visit",
    fr: "Visiter",
    de: "Besuchen",
    zh: "访问",
    it: "Visita",
    ru: "Открыть",
  },
  sister_popoyo_lead: {
    es: "¿Estás en Popoyo o Tola? Visita",
    en: "Are you in Popoyo or Tola? Visit",
    fr: "Tu es à Popoyo ou Tola ? Visite",
    de: "Bist du in Popoyo oder Tola? Besuche",
    zh: "你在 Popoyo 或 Tola 吗?访问",
    it: "Sei a Popoyo o Tola? Visita",
    ru: "Вы в Popoyo или Tola? Откройте",
  },
  sister_dnn_lead: {
    es: "¿Nómada digital en Nicaragua? Visita",
    en: "Digital nomad in Nicaragua? Visit",
    fr: "Nomade numérique au Nicaragua ? Visite",
    de: "Digitaler Nomade in Nicaragua? Besuche",
    zh: "在尼加拉瓜做数字游民?访问",
    it: "Nomade digitale in Nicaragua? Visita",
    ru: "Цифровой кочевник в Nicaragua? Откройте",
  },
};

export function t(lang, key) {
  const e = T[key];
  if (!e) return key;
  return e[lang] || e.en || key;
}
